import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHRMS } from "../context/HRMSContext.jsx";
import api, { API_BASE_URL } from "../services/api.js";
import DatePicker from "../components/DatePicker.jsx";
import Message from "../components/Message.jsx";
import PermissionGuard from "../components/PermissionGuard.jsx";
import CommonTable from "../components/common/CommonTable.jsx";
import FileUpload from "../components/FileUpload.jsx";
import "bootstrap-icons/font/bootstrap-icons.css";
//import App from '../App.css';

import { MODULES, ACTIONS, usePermissions } from "../context/PermissionsContext.jsx";

const getOrdinalMonth = (num) => {
  const n = parseInt(num, 10);
  if (isNaN(n)) return `${num || ''} Month`;
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]} Month`;
};

function Workers() {
  const {
    state,
    loadWorkers,

    loadProcessStages,
    loadCountries,
    loadStates,
    loadCities,
    loadCompanyIdTypes,
    loadJewelleryGroups,
    loadStoneTypes,
    loadCurrencies,
    loadShifts,
    loadSettingTypes,
  } = useHRMS();
  const { hasPermission } = usePermissions();
  const [showForm, setShowForm] = useState(false);
  const [editingWorker, setEditingWorker] = useState(null);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const initialLoadRef = useRef(false);
  const emptyForm = {
    worker_unid: "",
    worker_name: "",
    alias_name: "",
    email: "",
    phone_no: "",
    website: "",
    department: "",
    position: "",
    monthly_salary: "",
    salary_type: "salary",
    joining_date: "",
    shiftId: "",

    notice_period: "",
    process_stage_id: "",
    rating: 0,
    reference: "",
    remarks: "",
    loan_allowed: false,
    loan_amount: "",
    loan_installment_id: "",
    allowed_fine_wt: "",
    commission_percentage: "",
    // bonus_percentage: "",  // Commented - Not in use
    bonus_amount: "", // Added - Bonus Amount field
    bonus_installment: "",
    beneficiary_name: "",
    account_number: "",
    bank_name: "",
    bank_address: "",
    swift_code: "",
    ifsc_code: "",
    note: "",
    id_type_id: "",
    id_number: "",
    processGlobalRate: "",
    processGlobalCurrency: "USD",
    processWeightType: "1",
    processGlobalAllowedLoss: "",
    stoneGlobalRate: "",
    stoneGlobalCurrency: "USD",
    jewelryGlobalRate: "",
    jewelryGlobalCurrency: "USD",
    jewelryWeightType: "1",
    jewelryChargesType: "1",
    settingGlobalRate: "",
    settingGlobalCurrency: "USD",
    // Overtime rules
    monday_multiplier: "1.0",
    monday_day_off: false,
    tuesday_multiplier: "1.0",
    tuesday_day_off: false,
    wednesday_multiplier: "1.0",
    wednesday_day_off: false,
    thursday_multiplier: "1.0",
    thursday_day_off: false,
    friday_multiplier: "1.0",
    friday_day_off: false,
    saturday_multiplier: "1.5",
    saturday_day_off: false,
    sunday_multiplier: "2.0",
    sunday_day_off: false,
  };
  const [formData, setFormData] = useState(emptyForm);
  const [activeTab, setActiveTab] = useState("personal");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [addressRows, setAddressRows] = useState([{ id: 1 }]);
  const [idRows, setIdRows] = useState([{ id: 1 }]);
  const [workerType, setWorkerType] = useState("worker");
  const [workerCategory, setWorkerCategory] = useState("0");
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [workerImages, setWorkerImages] = useState([]);
  const [workerPdfs, setWorkerPdfs] = useState([]);
  const [idDocuments, setIdDocuments] = useState({});
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [workerNameSuggestions, setWorkerNameSuggestions] = useState([]);
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);
  const [showWorkerSuggestions, setShowWorkerSuggestions] = useState(false);
  const [departmentSuggestions, setDepartmentSuggestions] = useState([]);

  const [contactSuggestions, setContactSuggestions] = useState([]);
  const [showContactSuggestions, setShowContactSuggestions] = useState(false);
  const [showDepartmentSuggestions, setShowDepartmentSuggestions] =
    useState(false);

  const [positionSuggestions, setPositionSuggestions] = useState([]);
  const [showPositionSuggestions, setShowPositionSuggestions] = useState(false);
  const [duplicateCheckResult, setDuplicateCheckResult] = useState({
    matchedWorkers: [],
    totalMatchedWorkers: 0,
    totalMatchedFields: 0,
  });
  const [pendingWorkerPayload, setPendingWorkerPayload] = useState(null);
  const [isSavingWorker, setIsSavingWorker] = useState(false);
  const isSavingWorkerRef = useRef(false);
  const [showFilters, setShowFilters] = useState(false);
  const [workerFilters, setWorkerFilters] = useState({
    worker_id: "",
    worker_name: "",
    contact_no: "",
    shiftId: "",
  });
  const [workersTableTotal, setWorkersTableTotal] = useState(0);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [actionLoadingText, setActionLoadingText] = useState("Loading...");

  // Global rate handlers
  const handleJewelryGlobalRateChange = (rate) => {
    if (rate !== "" && parseFloat(rate) < 0) return;
    const updatedFormData = { ...formData, jewelryGlobalRate: rate };

    // Apply to all category rows
    if (Array.isArray(state.jewelleryGroups)) {
      state.jewelleryGroups.forEach((category) => {
        updatedFormData[`category_${category.id}_rate`] = rate;
      });
    }

    setFormData(updatedFormData);
  };

  const handleJewelryGlobalCurrencyChange = (currency) => {
    const updatedFormData = { ...formData, jewelryGlobalCurrency: currency };

    // Apply to all category rows
    if (Array.isArray(state.jewelleryGroups)) {
      state.jewelleryGroups.forEach((category) => {
        updatedFormData[`category_${category.id}_currency`] = currency;
      });
    }

    setFormData(updatedFormData);
  };

  const handleProcessGlobalRateChange = (rate) => {
    if (rate !== "" && parseFloat(rate) < 0) return;
    const updatedFormData = { ...formData, processGlobalRate: rate };

    // Apply to all process rows
    if (Array.isArray(state.processStages)) {
      state.processStages.forEach((stage) => {
        updatedFormData[`process_${stage.id}_rate`] = rate;
      });
    }

    setFormData(updatedFormData);
  };

  const handleProcessGlobalCurrencyChange = (currency) => {
    const updatedFormData = { ...formData, processGlobalCurrency: currency };

    // Apply to all process rows
    if (Array.isArray(state.processStages)) {
      state.processStages.forEach((stage) => {
        updatedFormData[`process_${stage.id}_currency`] = currency;
      });
    }

    setFormData(updatedFormData);
  };

  const handleStoneGlobalRateChange = (rate) => {
    if (rate !== "" && parseFloat(rate) < 0) return;
    const updatedFormData = { ...formData, stoneGlobalRate: rate };

    // Apply to all stone rows
    if (Array.isArray(state.stoneTypes)) {
      state.stoneTypes.forEach((stoneType) => {
        updatedFormData[`stone_${stoneType.id}_rate`] = rate;
      });
    }

    setFormData(updatedFormData);
  };

  const handleStoneGlobalCurrencyChange = (currency) => {
    const updatedFormData = { ...formData, stoneGlobalCurrency: currency };

    // Apply to all stone rows
    if (Array.isArray(state.stoneTypes)) {
      state.stoneTypes.forEach((stoneType) => {
        updatedFormData[`stone_${stoneType.id}_currency`] = currency;
      });
    }

    setFormData(updatedFormData);
  };

  const handleSettingGlobalRateChange = (rate) => {
    if (rate !== "" && parseFloat(rate) < 0) return;
    const updatedFormData = { ...formData, settingGlobalRate: rate };

    // Apply to all setting rows
    if (Array.isArray(state.settingTypes)) {
      state.settingTypes.forEach((diamondType) => {
        updatedFormData[`diamond_${diamondType.id}_rate`] = rate;
      });
    }

    setFormData(updatedFormData);
  };

  const handleSettingGlobalCurrencyChange = (currency) => {
    const updatedFormData = { ...formData, settingGlobalCurrency: currency };

    // Apply to all setting rows
    if (Array.isArray(state.settingTypes)) {
      state.settingTypes.forEach((diamondType) => {
        updatedFormData[`diamond_${diamondType.id}_currency`] = currency;
      });
    }

    setFormData(updatedFormData);
  };

  const handleJewelryGlobalWeightTypeChange = (weightType) => {
    const updatedFormData = { ...formData, jewelryWeightType: weightType };

    // Apply to all category rows
    if (Array.isArray(state.jewelleryGroups)) {
      state.jewelleryGroups.forEach((category) => {
        updatedFormData[`category_${category.id}_weightType`] = weightType;
      });
    }

    setFormData(updatedFormData);
  };

  const handleJewelryGlobalChargesTypeChange = (chargesType) => {
    const updatedFormData = { ...formData, jewelryChargesType: chargesType };

    // Apply to all category rows
    if (Array.isArray(state.jewelleryGroups)) {
      state.jewelleryGroups.forEach((category) => {
        updatedFormData[`category_${category.id}_chargesType`] = chargesType;
      });
    }

    setFormData(updatedFormData);
  };

  const handleProcessGlobalWeightTypeChange = (weightType) => {
    const updatedFormData = { ...formData, processWeightType: weightType };

    // Apply to all process rows
    if (Array.isArray(state.processStages)) {
      state.processStages.forEach((stage) => {
        updatedFormData[`process_${stage.id}_weightType`] = weightType;
      });
    }

    setFormData(updatedFormData);
  };

  const handleProcessGlobalAllowedLossChange = (allowedLoss) => {
    if (allowedLoss !== "" && parseFloat(allowedLoss) < 0) return;
    const updatedFormData = {
      ...formData,
      processGlobalAllowedLoss: allowedLoss,
    };

    // Apply to all process rows
    if (Array.isArray(state.processStages)) {
      state.processStages.forEach((stage) => {
        updatedFormData[`process_${stage.id}_allowedLoss`] = allowedLoss;
      });
    }

    setFormData(updatedFormData);
  };

  const addIdRow = () => {
    const newId = Math.max(...idRows.map((row) => row.id)) + 1;
    setIdRows([...idRows, { id: newId }]);
  };

  const removeIdRow = (id) => {
    if (idRows.length > 1) {
      setIdRows(idRows.filter((row) => row.id !== id));
    }
  };

  const addAddressRow = () => {
    const newId = Math.max(...addressRows.map((row) => row.id)) + 1;
    setAddressRows([...addressRows, { id: newId }]);
  };

  const removeAddressRow = (id) => {
    if (addressRows.length > 1) {
      setAddressRows(addressRows.filter((row) => row.id !== id));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSavingWorkerRef.current) return;
    isSavingWorkerRef.current = true;
    setIsSavingWorker(true);
    try {
      // Prepare addresses data
      const addresses = addressRows
        .map((row) => ({
          address_type: formData[`address_type${row.id}`] || "Shipping",
          address_line1: formData[`address_line1${row.id}`] || "",
          address_line2: formData[`address_line2${row.id}`] || "",
          country_id: formData[`country_id${row.id}`] || "",
          state_id: formData[`state_id${row.id}`] || "",
          city_id: formData[`city_id${row.id}`] || "",
          zip_code: formData[`zip_code${row.id}`] || "",
        }))
        .filter((addr) => addr.address_line1); // Only include rows with address data

      // Prepare accounts data
      const accounts = [
        {
          beneficiary_name: formData.beneficiary_name || "",
          account_number: formData.account_number || "",
          bank_name: formData.bank_name || "",
          bank_address: formData.bank_address || "",
          swift_code: formData.swift_code || "",
          ifsc_code: formData.ifsc_code || "",
          note: formData.note || "",
        },
      ].filter((acc) => acc.beneficiary_name || acc.account_number); // Only include if has data

      // Prepare IDs data from multiple rows
      const ids = idRows
        .map((row) => {
          const idType = formData[`id_type_id${row.id}`];
          const idNumber = formData[`id_number${row.id}`];

          // Get the first image from workerImages as worker_image_id (if exists)
          const workerImageId =
            workerImages.length > 0 ? workerImages[0].id : null;

          return {
            id_type_id: idType || "",
            id_number: idNumber || "",
            worker_image_id: workerImageId,
            id_row_id: row.id,
          };
        })
        .filter((id) => id.id_type_id && id.id_number); // Only include if both fields have data

      // Prepare category prices data
      const categoryPrices = [];

      // Global jewelry rate
      if (formData.jewelryGlobalRate) {
        categoryPrices.push({
          jewellery_group_id: 0, // Global rate
          rate: formData.jewelryGlobalRate,
          currency: formData.jewelryGlobalCurrency || "USD",
          weight_type: formData.jewelryWeightType || "1",
          charges_type: formData.jewelryChargesType || "1",
        });
      }

      // Individual category rates
      if (Array.isArray(state.jewelleryGroups)) {
        state.jewelleryGroups.forEach((category) => {
          const rate = formData[`category_${category.id}_rate`];
          if (rate) {
            categoryPrices.push({
              jewellery_group_id: category.id,
              rate: parseFloat(rate),
              currency: formData[`category_${category.id}_currency`] || "USD",
              weight_type:
                formData[`category_${category.id}_weightType`] || "",
              charges_type:
                formData[`category_${category.id}_chargesType`] || "",
            });
          }
        });
      }

      // Prepare process prices data
      const processPrices = [];

      // Global process rate
      if (formData.processGlobalRate) {
        processPrices.push({
          process_stage_id: 0, // Global rate
          rate: formData.processGlobalRate,
          currency: formData.processGlobalCurrency || "USD",
          weight_type: formData.processWeightType || "1",
          allowed_loss: formData.processGlobalAllowedLoss || null,
        });
      }

      // Individual process stage rates
      if (Array.isArray(state.processStages)) {
        state.processStages.forEach((stage) => {
          const rate = formData[`process_${stage.id}_rate`];
          if (rate) {
            processPrices.push({
              process_stage_id: stage.id,
              rate: parseFloat(rate),
              currency: formData[`process_${stage.id}_currency`] || "USD",
              weight_type: formData[`process_${stage.id}_weightType`] || "1",
              allowed_loss: formData[`process_${stage.id}_allowedLoss`] || null,
            });
          }
        });
      }

      // Prepare stone prices data
      const stonePrices = [];

      // Global stone rate
      if (formData.stoneGlobalRate) {
        stonePrices.push({
          stone_type_id: 0, // Global rate
          rate: formData.stoneGlobalRate,
          currency: formData.stoneGlobalCurrency || "USD",
        });
      }

      // Individual stone type rates
      if (Array.isArray(state.stoneTypes)) {
        state.stoneTypes.forEach((stoneType) => {
          const rate =
            formData[`stone_${stoneType.id}_rate`] || formData.stoneGlobalRate;
          const currency =
            formData[`stone_${stoneType.id}_currency`] ||
            formData.stoneGlobalCurrency ||
            "USD";
          if (rate) {
            stonePrices.push({
              stone_type_id: stoneType.id,
              rate: parseFloat(rate),
              currency,
            });
          }
        });
      }

      // Prepare setting prices data
      const settingPrices = [];

      // Global setting rate
      if (formData.settingGlobalRate) {
        settingPrices.push({
          diamond_type_id: 0, // Global rate
          rate: formData.settingGlobalRate,
          currency: formData.settingGlobalCurrency || "USD",
        });
      }

      // Individual diamond type rates
      if (Array.isArray(state.settingTypes)) {
        state.settingTypes.forEach((diamondType) => {
          const rate =
            formData[`diamond_${diamondType.id}_rate`] ||
            formData.settingGlobalRate;
          const currency =
            formData[`diamond_${diamondType.id}_currency`] ||
            formData.settingGlobalCurrency ||
            "USD";
          if (rate) {
            settingPrices.push({
              diamond_type_id: diamondType.id,
              rate: parseFloat(rate),
              currency,
            });
          }
        });
      }

      // Prepare overtime rules data
      const overtimeRules = [
        {
          day_name: "Monday",
          multiplier: parseFloat(formData.monday_multiplier) || 1.0,
          day_off: formData.monday_day_off || false,
        },
        {
          day_name: "Tuesday",
          multiplier: parseFloat(formData.tuesday_multiplier) || 1.0,
          day_off: formData.tuesday_day_off || false,
        },
        {
          day_name: "Wednesday",
          multiplier: parseFloat(formData.wednesday_multiplier) || 1.0,
          day_off: formData.wednesday_day_off || false,
        },
        {
          day_name: "Thursday",
          multiplier: parseFloat(formData.thursday_multiplier) || 1.0,
          day_off: formData.thursday_day_off || false,
        },
        {
          day_name: "Friday",
          multiplier: parseFloat(formData.friday_multiplier) || 1.0,
          day_off: formData.friday_day_off || false,
        },
        {
          day_name: "Saturday",
          multiplier: parseFloat(formData.saturday_multiplier) || 1.5,
          day_off: formData.saturday_day_off || false,
        },
        {
          day_name: "Sunday",
          multiplier: parseFloat(formData.sunday_multiplier) || 2.0,
          day_off: formData.sunday_day_off || false,
        },
      ];

      // Prepare documents with proper structure
      const documents = Object.entries(idDocuments).flatMap(([rowId, docs]) =>
        docs.map((doc) => ({
          ...doc,
          id_row_id: parseInt(rowId),
        })),
      );

      // Prepare PDFs with proper structure
      const pdfs = workerPdfs.map((pdf) => ({
        ...pdf,
        document_type: "personal_pdf",
      }));

      const isEditingEmployeeSubmit = Boolean(
        editingWorker &&
        (editingWorker.type === 2 ||
          editingWorker.type === "2" ||
          editingWorker.type === "employee" ||
          editingWorker.worker_type === 2 ||
          editingWorker.worker_type === "2" ||
          (editingWorker.worker_unid &&
            String(editingWorker.worker_unid)
              .trim()
              .toUpperCase()
              .startsWith("E")))
      );
      const isRegisteredWorkerSubmit = Boolean(
        editingWorker && Number(editingWorker.registered) === 1
      );

      const resolvedType = isEditingEmployeeSubmit
        ? "employee"
        : editingWorker
          ? "worker"
          : workerType;

      const resolvedWorkerType = isEditingEmployeeSubmit
        ? 2
        : isRegisteredWorkerSubmit
          ? Number(editingWorker.worker_type ?? 0)
          : Number(workerCategory);

      const payload = {
        worker_unid: formData.worker_unid || null,
        worker_name: formData.worker_name,
        alias_name: formData.alias_name,
        email: formData.email,
        phone_no: formData.phone_no,
        website: formData.website,
        joining_date: formData.joining_date,
        department: formData.department,
        position: formData.position,
        monthly_salary: formData.monthly_salary,
        salary_type: formData.salary_type || "salary",
        notice_period: formData.notice_period,
        process_stage_id:
          resolvedType === "employee" ? -1 : formData.process_stage_id,
        rating: formData.rating,
        reference: formData.reference,
        remarks: formData.remarks,
        shiftId: formData.shiftId ? parseInt(formData.shiftId, 10) : null,
        type: resolvedType,
        worker_type: resolvedWorkerType,
        loan_allowed: formData.loan_allowed || false,
        loan_amount:
          formData.loan_allowed && formData.loan_amount
            ? parseFloat(formData.loan_amount)
            : null,
        loan_installment_id:
          formData.loan_allowed && formData.loan_installment_id
            ? parseInt(formData.loan_installment_id)
            : null,
        allowed_fine_wt: formData.allowed_fine_wt
          ? parseFloat(formData.allowed_fine_wt)
          : null,
        commission_percentage: formData.commission_percentage
          ? parseFloat(formData.commission_percentage)
          : null,
        // bonus_percentage: formData.bonus_percentage ? parseFloat(formData.bonus_percentage) : null,  // Commented - Not in use
        bonus_amount: formData.bonus_amount
          ? parseFloat(formData.bonus_amount)
          : null, // Added - Bonus Amount field
        bonus_installment: formData.bonus_installment
          ? parseInt(formData.bonus_installment)
          : null,
        addresses,
        accounts,
        ids,
        categoryPrices,
        processPrices,
        stonePrices,
        settingPrices,
        overtimeRules,
        images: workerImages,
        documents: documents,
        pdfs: pdfs,
      };

      if (!editingWorker) {
        const duplicateResult = await api.workers.checkDuplicate(payload);
        if (duplicateResult?.hasMatches) {
          isSavingWorkerRef.current = false;
          setIsSavingWorker(false);
          setPendingWorkerPayload(payload);
          setDuplicateCheckResult(duplicateResult);
          setShowDuplicateModal(true);
          return;
        }
      }

      await saveWorker(payload);
    } catch (error) {
      isSavingWorkerRef.current = false;
      setIsSavingWorker(false);
      setMessage({
        text: `Error saving worker: ${error.message || "Unknown error"}`,
        type: "error",
      });
    }
  };

  const closeDuplicateModal = () => {
    isSavingWorkerRef.current = false;
    setIsSavingWorker(false);
    setShowDuplicateModal(false);
    setDuplicateCheckResult({
      matchedWorkers: [],
      totalMatchedWorkers: 0,
      totalMatchedFields: 0,
    });
    setPendingWorkerPayload(null);
  };

  const saveWorker = async (payload) => {
    isSavingWorkerRef.current = true;
    setIsSavingWorker(true);
    try {
      if (editingWorker) {
        await api.workers.update(editingWorker.id, payload);
        setMessage({ text: "Worker updated successfully!", type: "success" });
      } else {
        await api.workers.create(payload);
        setMessage({ text: "Worker added successfully!", type: "success" });
      }

      await loadWorkers();
      setFormData(emptyForm);
      setShowForm(false);
      setEditingWorker(null);
      setAddressRows([{ id: 1 }]);
      setIdRows([{ id: 1 }]);
      setWorkerType("worker");
      setWorkerCategory("0");
      setWorkerImages([]);
      setWorkerPdfs([]);
      setIdDocuments({});
      closeDuplicateModal();
    } finally {
      isSavingWorkerRef.current = false;
      setIsSavingWorker(false);
    }
  };

  const handleDuplicateSaveConfirm = async () => {
    if (!pendingWorkerPayload || isSavingWorkerRef.current) return;

    try {
      await saveWorker(pendingWorkerPayload);
    } catch (error) {
      isSavingWorkerRef.current = false;
      setIsSavingWorker(false);
      setMessage({
        text: `Error saving worker: ${error.message || "Unknown error"}`,
        type: "error",
      });
    }
  };

  const openImageModal = (images, index) => {
    setModalImages(images);
    setCurrentImageIndex(index);
    setShowImageModal(true);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % modalImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + modalImages.length) % modalImages.length,
    );
  };

  const handleInfo = async (worker) => {
    if (isActionLoading) return;
    setIsActionLoading(true);
    setActionLoadingText("Loading worker details...");
    try {
      const fullWorkerData = await api.workers.getById(worker.id);
      setSelectedWorker(fullWorkerData);
      setShowInfoModal(true);
    } catch (error) {
      setSelectedWorker(worker);
      setShowInfoModal(true);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleCopy = async (worker) => {
    if (isActionLoading) return;
    // Copy mode - don't set editingWorker so it creates a new record
    setEditingWorker(null);
    closeDuplicateModal();
    setIsActionLoading(true);
    setActionLoadingText("Preparing worker copy...");

    try {
      // Fetch complete worker data with all related tables
      const fullWorkerData = await api.workers.getById(worker.id);

      // Set worker type from loaded data
      const resolvedWorkerType =
        fullWorkerData.type === 2 ||
          fullWorkerData.type === "2" ||
          fullWorkerData.type === "employee"
          ? "employee"
          : "worker";
      setWorkerType(resolvedWorkerType);
      setWorkerCategory(
        fullWorkerData.worker_type === 1 || fullWorkerData.worker_type === "1"
          ? "1"
          : "0"
      );

      // Get next UNID for the new worker
      let nextUnid = "";
      try {
        const response = await api.workers.getNextUnid(resolvedWorkerType);
        nextUnid = response.nextUnid;
      } catch (error) {
        console.error("Error getting next UNID:", error);
      }

      // Set form data with complete worker information but with new UNID
      const baseFormData = {
        worker_unid: nextUnid, // New UNID for copied worker
        worker_name: fullWorkerData.worker_name || "",
        alias_name: "",
        email: "",
        phone_no: fullWorkerData.phone_no || "",
        website: fullWorkerData.website || "",
        department: fullWorkerData.department || "",
        position: fullWorkerData.position || "",
        monthly_salary: fullWorkerData.monthly_salary || "",
        salary_type: fullWorkerData.salary_type || "salary",
        joining_date: fullWorkerData.joining_date || "",
        shiftId: fullWorkerData.shiftId ? String(fullWorkerData.shiftId) : "",
        notice_period: fullWorkerData.notice_period || "",
        process_stage_id:
          fullWorkerData.process_stage_id &&
            Number(fullWorkerData.process_stage_id) > 0
            ? String(fullWorkerData.process_stage_id)
            : "",
        rating: fullWorkerData.rating || 0,
        reference: fullWorkerData.reference || "",
        remarks: fullWorkerData.remarks || "",
        loan_allowed: "",
        loan_amount: "",
        loan_installment_id: "",
        allowed_fine_wt: fullWorkerData.allowed_fine_wt || "",
        commission_percentage: "",
        // bonus_percentage:  "",  // Commented - Not in use
        bonus_amount: "", // Added - Bonus Amount field
        bonus_installment: "",
        // Account details not copied - user must enter manually
        beneficiary_name: "",
        account_number: "",
        bank_name: "",
        bank_address: "",
        swift_code: "",
        ifsc_code: "",
        note: "",
        // Load ID info from first ID if exists
        id_type_id: fullWorkerData.ids?.[0]?.id_type_id || "",
        id_number: fullWorkerData.ids?.[0]?.id_number || "",
        // Load price criteria from saved data
        processGlobalRate:
          fullWorkerData.processPrices?.find((p) => p.process_stage_id === 0)
            ?.rate || "",
        processGlobalCurrency:
          fullWorkerData.processPrices?.find((p) => p.process_stage_id === 0)
            ?.currency || "USD",
        processWeightType:
          fullWorkerData.processPrices?.find((p) => p.process_stage_id === 0)
            ?.weight_type || "1",
        stoneGlobalRate:
          fullWorkerData.stonePrices?.find((s) => s.stone_type_id === 0)
            ?.rate || "",
        stoneGlobalCurrency:
          fullWorkerData.stonePrices?.find((s) => s.stone_type_id === 0)
            ?.currency || "USD",
        jewelryGlobalRate:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.rate || "",
        jewelryGlobalCurrency:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.currency || "USD",
        jewelryWeightType:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.weight_type || "1",
        jewelryChargesType:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.charges_type || "1",
      };

      // Load overtime rules
      if (
        fullWorkerData.overtimeRules &&
        fullWorkerData.overtimeRules.length > 0
      ) {
        fullWorkerData.overtimeRules.forEach((rule) => {
          const dayName = rule.day_name.toLowerCase();
          baseFormData[`${dayName}_multiplier`] = rule.multiplier || "1.0";
          baseFormData[`${dayName}_day_off`] = rule.day_off || false;
        });
      }

      // Load first address data into form fields with proper row ID mapping
      if (fullWorkerData.addresses && fullWorkerData.addresses.length > 0) {
        fullWorkerData.addresses.forEach((addr, index) => {
          const rowId = index + 1;
          baseFormData[`address_type${rowId}`] =
            addr.address_type || "Shipping";
          baseFormData[`address_line1${rowId}`] = addr.address_line1 || "";
          baseFormData[`address_line2${rowId}`] = addr.address_line2 || "";
          baseFormData[`country_id${rowId}`] = addr.country_id
            ? String(addr.country_id)
            : "";
          baseFormData[`state_id${rowId}`] = addr.state_id
            ? String(addr.state_id)
            : "";
          baseFormData[`city_id${rowId}`] = addr.city_id
            ? String(addr.city_id)
            : "";
          baseFormData[`zip_code${rowId}`] = addr.zip_code || "";
        });
      }

      // Add individual price rates to form data
      // Load category prices
      if (
        fullWorkerData.categoryPrices &&
        fullWorkerData.categoryPrices.length > 0
      ) {
        fullWorkerData.categoryPrices.forEach((cp) => {
          if (cp.jewellery_group_id && cp.jewellery_group_id !== 0) {
            baseFormData[`category_${cp.jewellery_group_id}_rate`] = cp.rate || "";
            baseFormData[`category_${cp.jewellery_group_id}_currency`] =
              cp.currency || "USD";
            baseFormData[`category_${cp.jewellery_group_id}_weightType`] = String(
              cp.weight_type || "1",
            );
            baseFormData[`category_${cp.jewellery_group_id}_chargesType`] = String(
              cp.charges_type || "1",
            );
          }
        });
      }

      // Load process prices
      if (
        fullWorkerData.processPrices &&
        fullWorkerData.processPrices.length > 0
      ) {
        fullWorkerData.processPrices.forEach((pp) => {
          if (pp.process_stage_id && pp.process_stage_id !== 0) {
            baseFormData[`process_${pp.process_stage_id}_rate`] = pp.rate || "";
            baseFormData[`process_${pp.process_stage_id}_currency`] =
              pp.currency || "USD";
            baseFormData[`process_${pp.process_stage_id}_weightType`] = String(
              pp.weight_type || "1",
            );
            baseFormData[`process_${pp.process_stage_id}_allowedLoss`] =
              pp.allowed_loss || "";
          }
        });
      }

      // Load stone prices
      if (fullWorkerData.stonePrices && fullWorkerData.stonePrices.length > 0) {
        fullWorkerData.stonePrices.forEach((sp) => {
          if (sp.stone_type_id && sp.stone_type_id !== 0) {
            baseFormData[`stone_${sp.stone_type_id}_rate`] = sp.rate || "";
            baseFormData[`stone_${sp.stone_type_id}_currency`] =
              sp.currency || "USD";
          }
        });
      }

      // Load setting prices
      if (
        fullWorkerData.settingPrices &&
        fullWorkerData.settingPrices.length > 0
      ) {
        // Load global setting rate
        const globalSetting = fullWorkerData.settingPrices.find(
          (s) => s.diamond_type_id === 0,
        );
        if (globalSetting) {
          baseFormData.settingGlobalRate = globalSetting.rate || "";
          baseFormData.settingGlobalCurrency = globalSetting.currency || "USD";
        }

        // Load individual diamond type rates
        fullWorkerData.settingPrices.forEach((sp) => {
          if (sp.diamond_type_id && sp.diamond_type_id !== 0) {
            baseFormData[`diamond_${sp.diamond_type_id}_rate`] = sp.rate || "";
            baseFormData[`diamond_${sp.diamond_type_id}_currency`] =
              sp.currency || "USD";
          }
        });
      }

      // Set the complete form data once
      setFormData(baseFormData);

      // Set ID rows from loaded data
      if (fullWorkerData.ids && fullWorkerData.ids.length > 0) {
        const idRowsData = fullWorkerData.ids.map((id, index) => ({
          id: index + 1,
        }));
        setIdRows(idRowsData);

        // Load ID data into form fields
        fullWorkerData.ids.forEach((id, index) => {
          const rowId = index + 1;
          baseFormData[`id_type_id${rowId}`] = id.id_type_id
            ? String(id.id_type_id)
            : "";
          baseFormData[`id_number${rowId}`] = id.id_number || "";
        });

        // Update form data with ID fields
        setFormData(baseFormData);
      } else {
        setIdRows([{ id: 1 }]);
      }

      // Set address rows from loaded data
      if (fullWorkerData.addresses && fullWorkerData.addresses.length > 0) {
        const addressRowsData = fullWorkerData.addresses.map((addr, index) => ({
          id: index + 1,
          address_type: addr.address_type || "Shipping",
          address_line1: addr.address_line1 || "",
          address_line2: addr.address_line2 || "",
          country_id: addr.country_id ? String(addr.country_id) : "",
          state_id: addr.state_id ? String(addr.state_id) : "",
          city_id: addr.city_id ? String(addr.city_id) : "",
          zip_code: addr.zip_code || "",
        }));
        setAddressRows(addressRowsData);
      } else {
        setAddressRows([
          {
            id: 1,
            address_type: "Shipping",
            address_line1: "",
            address_line2: "",
            country_id: "",
            state_id: "",
            city_id: "",
            zip_code: "",
          },
        ]);
      }

      // Load existing images
      if (fullWorkerData.images && fullWorkerData.images.length > 0) {
        setWorkerImages(fullWorkerData.images);
      } else {
        setWorkerImages([]);
      }

      // Load existing PDFs
      if (fullWorkerData.pdfs && fullWorkerData.pdfs.length > 0) {
        setWorkerPdfs(fullWorkerData.pdfs);
      } else {
        setWorkerPdfs([]);
      }

      // Open form after all state is set
      setShowForm(true);
    } catch (error) {
      console.error("Error copying worker:", error);
      setMessage({
        text: `Error copying worker: ${error.message || "Unknown error"}`,
        type: "error",
      });
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleEdit = async (worker) => {
    if (isActionLoading) return;
    setEditingWorker(worker);
    setIsActionLoading(true);
    setActionLoadingText("Loading worker for edit...");

    try {
      // Fetch complete worker data with all related tables
      const fullWorkerData = await api.workers.getById(worker.id);
      setEditingWorker(fullWorkerData);

      // Set worker type from loaded data
      const resolvedWorkerType =
        fullWorkerData.type === 2 ||
          fullWorkerData.type === "2" ||
          fullWorkerData.type === "employee"
          ? "employee"
          : "worker";
      setWorkerType(resolvedWorkerType);
      setWorkerCategory(
        fullWorkerData.worker_type === 1 || fullWorkerData.worker_type === "1"
          ? "1"
          : "0"
      );

      // Set form data with complete worker information including individual prices
      const baseFormData = {
        worker_unid: fullWorkerData.worker_unid || "",
        worker_name: fullWorkerData.worker_name || "",
        alias_name: fullWorkerData.alias_name || "",
        email: fullWorkerData.email || "",
        phone_no: fullWorkerData.phone_no || "",
        website: fullWorkerData.website || "",
        department: fullWorkerData.department || "",
        position: fullWorkerData.position || "",
        monthly_salary: fullWorkerData.monthly_salary || "",
        salary_type: fullWorkerData.salary_type || "salary",
        joining_date: fullWorkerData.joining_date || "",
        shiftId: fullWorkerData.shiftId ? String(fullWorkerData.shiftId) : "",
        notice_period: fullWorkerData.notice_period || "",
        process_stage_id:
          fullWorkerData.process_stage_id &&
            Number(fullWorkerData.process_stage_id) > 0
            ? String(fullWorkerData.process_stage_id)
            : "",
        rating: fullWorkerData.rating || 0,
        reference: fullWorkerData.reference || "",
        remarks: fullWorkerData.remarks || "",
        loan_allowed: fullWorkerData.loan_allowed || false,
        loan_amount: fullWorkerData.loan_amount || "",
        loan_installment_id: fullWorkerData.loan_installment_id || "",
        allowed_fine_wt: fullWorkerData.allowed_fine_wt || "",
        commission_percentage: fullWorkerData.commission_percentage || "",
        // bonus_percentage: fullWorkerData.bonus_percentage || "",  // Commented - Not in use
        bonus_amount: fullWorkerData.bonus_amount || "", // Added - Bonus Amount field
        bonus_installment: fullWorkerData.bonus_installment || "",
        // Load account info from first account if exists
        beneficiary_name: fullWorkerData.accounts?.[0]?.beneficiary_name || "",
        account_number: fullWorkerData.accounts?.[0]?.account_number || "",
        bank_name: fullWorkerData.accounts?.[0]?.bank_name || "",
        bank_address: fullWorkerData.accounts?.[0]?.bank_address || "",
        swift_code: fullWorkerData.accounts?.[0]?.swift_code || "",
        ifsc_code: fullWorkerData.accounts?.[0]?.ifsc_code || "",
        note: fullWorkerData.accounts?.[0]?.note || "",
        // Load ID info from first ID if exists
        id_type_id: fullWorkerData.ids?.[0]?.id_type_id || "",
        id_number: fullWorkerData.ids?.[0]?.id_number || "",
        // Load price criteria from saved data
        processGlobalRate:
          fullWorkerData.processPrices?.find((p) => p.process_stage_id === 0)
            ?.rate || "",
        processGlobalCurrency:
          fullWorkerData.processPrices?.find((p) => p.process_stage_id === 0)
            ?.currency || "USD",
        processWeightType:
          fullWorkerData.processPrices?.find((p) => p.process_stage_id === 0)
            ?.weight_type || "1",
        stoneGlobalRate:
          fullWorkerData.stonePrices?.find((s) => s.stone_type_id === 0)
            ?.rate || "",
        stoneGlobalCurrency:
          fullWorkerData.stonePrices?.find((s) => s.stone_type_id === 0)
            ?.currency || "USD",
        jewelryGlobalRate:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.rate || "",
        jewelryGlobalCurrency:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.currency || "USD",
        jewelryWeightType:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.weight_type || "1",
        jewelryChargesType:
          fullWorkerData.categoryPrices?.find((c) => c.jewellery_group_id === 0)
            ?.charges_type || "1",
      };

      // Load overtime rules
      if (
        fullWorkerData.overtimeRules &&
        fullWorkerData.overtimeRules.length > 0
      ) {
        fullWorkerData.overtimeRules.forEach((rule) => {
          const dayName = rule.day_name.toLowerCase();
          baseFormData[`${dayName}_multiplier`] = rule.multiplier || "1.0";
          baseFormData[`${dayName}_day_off`] = rule.day_off || false;
        });
      }

      // Load first address data into form fields with proper row ID mapping
      if (fullWorkerData.addresses && fullWorkerData.addresses.length > 0) {
        fullWorkerData.addresses.forEach((addr, index) => {
          const rowId = index + 1;
          baseFormData[`address_type${rowId}`] =
            addr.address_type || "Shipping";
          baseFormData[`address_line1${rowId}`] = addr.address_line1 || "";
          baseFormData[`address_line2${rowId}`] = addr.address_line2 || "";
          baseFormData[`country_id${rowId}`] = addr.country_id
            ? String(addr.country_id)
            : "";
          baseFormData[`state_id${rowId}`] = addr.state_id
            ? String(addr.state_id)
            : "";
          baseFormData[`city_id${rowId}`] = addr.city_id
            ? String(addr.city_id)
            : "";
          baseFormData[`zip_code${rowId}`] = addr.zip_code || "";
        });
      }

      // Add individual price rates to form data
      // Load category prices
      if (
        fullWorkerData.categoryPrices &&
        fullWorkerData.categoryPrices.length > 0
      ) {
        fullWorkerData.categoryPrices.forEach((cp) => {
          if (cp.jewellery_group_id && cp.jewellery_group_id !== 0) {
            baseFormData[`category_${cp.jewellery_group_id}_rate`] = cp.rate || "";
            baseFormData[`category_${cp.jewellery_group_id}_currency`] =
              cp.currency || "USD";
            baseFormData[`category_${cp.jewellery_group_id}_weightType`] = String(
              cp.weight_type || "1",
            );
            baseFormData[`category_${cp.jewellery_group_id}_chargesType`] = String(
              cp.charges_type || "1",
            );
          }
        });
      }

      // Load process prices
      if (
        fullWorkerData.processPrices &&
        fullWorkerData.processPrices.length > 0
      ) {
        fullWorkerData.processPrices.forEach((pp) => {
          if (pp.process_stage_id && pp.process_stage_id !== 0) {
            baseFormData[`process_${pp.process_stage_id}_rate`] = pp.rate || "";
            baseFormData[`process_${pp.process_stage_id}_currency`] =
              pp.currency || "USD";
            baseFormData[`process_${pp.process_stage_id}_weightType`] = String(
              pp.weight_type || "1",
            );
            baseFormData[`process_${pp.process_stage_id}_allowedLoss`] =
              pp.allowed_loss || "";
          }
        });
      }

      // Load stone prices
      if (fullWorkerData.stonePrices && fullWorkerData.stonePrices.length > 0) {
        fullWorkerData.stonePrices.forEach((sp) => {
          if (sp.stone_type_id && sp.stone_type_id !== 0) {
            baseFormData[`stone_${sp.stone_type_id}_rate`] = sp.rate || "";
            baseFormData[`stone_${sp.stone_type_id}_currency`] =
              sp.currency || "USD";
          }
        });
      }

      // Load setting prices
      if (
        fullWorkerData.settingPrices &&
        fullWorkerData.settingPrices.length > 0
      ) {
        // Load global setting rate
        const globalSetting = fullWorkerData.settingPrices.find(
          (s) => s.diamond_type_id === 0,
        );
        if (globalSetting) {
          baseFormData.settingGlobalRate = globalSetting.rate || "";
          baseFormData.settingGlobalCurrency = globalSetting.currency || "USD";
        }

        // Load individual diamond type rates
        fullWorkerData.settingPrices.forEach((sp) => {
          if (sp.diamond_type_id && sp.diamond_type_id !== 0) {
            baseFormData[`diamond_${sp.diamond_type_id}_rate`] = sp.rate || "";
            baseFormData[`diamond_${sp.diamond_type_id}_currency`] =
              sp.currency || "USD";
          }
        });
      }

      // Set the complete form data once
      setFormData(baseFormData);

      // Set ID rows from loaded data
      if (fullWorkerData.ids && fullWorkerData.ids.length > 0) {
        const idRowsData = fullWorkerData.ids.map((id, index) => ({
          id: index + 1,
        }));
        setIdRows(idRowsData);

        // Load ID data into form fields
        fullWorkerData.ids.forEach((id, index) => {
          const rowId = index + 1;
          baseFormData[`id_type_id${rowId}`] = id.id_type_id
            ? String(id.id_type_id)
            : "";
          baseFormData[`id_number${rowId}`] = id.id_number || "";
        });

        // Update form data with ID fields
        setFormData(baseFormData);
      } else {
        setIdRows([{ id: 1 }]);
      }

      // Set address rows from loaded data
      if (fullWorkerData.addresses && fullWorkerData.addresses.length > 0) {
        const addressRowsData = fullWorkerData.addresses.map((addr, index) => ({
          id: index + 1,
          address_type: addr.address_type || "Shipping",
          address_line1: addr.address_line1 || "",
          address_line2: addr.address_line2 || "",
          country_id: addr.country_id ? String(addr.country_id) : "",
          state_id: addr.state_id ? String(addr.state_id) : "",
          city_id: addr.city_id ? String(addr.city_id) : "",
          zip_code: addr.zip_code || "",
        }));
        setAddressRows(addressRowsData);
      } else {
        setAddressRows([
          {
            id: 1,
            address_type: "Shipping",
            address_line1: "",
            address_line2: "",
            country_id: "",
            state_id: "",
            city_id: "",
            zip_code: "",
          },
        ]);
      }

      // Load existing images
      if (fullWorkerData.images && fullWorkerData.images.length > 0) {
        setWorkerImages(fullWorkerData.images);
      } else {
        setWorkerImages([]);
      }

      // Load existing PDFs
      console.log("Loading PDFs in edit mode:", fullWorkerData.pdfs);
      if (fullWorkerData.pdfs && fullWorkerData.pdfs.length > 0) {
        setWorkerPdfs(fullWorkerData.pdfs);
        console.log("PDFs set to state:", fullWorkerData.pdfs);
      } else {
        setWorkerPdfs([]);
        console.log("No PDFs found, setting empty array");
      }

      // Load existing documents
      if (fullWorkerData.documents && fullWorkerData.documents.length > 0) {
        const documentsMap = {};
        fullWorkerData.documents.forEach((doc) => {
          const rowId =
            doc.id_row_id !== null && doc.id_row_id !== undefined
              ? doc.id_row_id + 1
              : null;

          if (rowId) {
            if (!documentsMap[rowId]) {
              documentsMap[rowId] = [];
            }
            documentsMap[rowId].push(doc);
          }
        });

        setIdDocuments(documentsMap);
      } else {
        setIdDocuments({});
      }

      // Open form after all state is set
      setShowForm(true);
    } catch (error) {
      // Fallback to basic data if API fails
      setFormData({
        worker_name: worker.name || "",
        alias_name: worker.aliasName || "",
        email: worker.email || "",
        phone_no: worker.contactNo || "",
        website: worker.website || "",
        department: worker.department || "",
        position: worker.position || "",
        monthly_salary: worker.salary || "",
        joining_date: worker.joiningDate || "",
        shiftId: worker.shiftId ? String(worker.shiftId) : "",
        notice_period: worker.noticePeriod || "",
        process_stage_id:
          worker.processStages && Number(worker.processStages) > 0
            ? String(worker.processStages)
            : "",
        rating: worker.workerRating || 0,
        reference: worker.reference || "",
        remarks: worker.remarks || "",
        beneficiary_name: "",
        account_number: "",
        bank_name: "",
        bank_address: "",
        swift_code: "",
        ifsc_code: "",
        note: "",
        id_type_id: "",
        id_number: "",
        processGlobalRate: "",
        processGlobalCurrency: "USD",
        processWeightType: "1",
        stoneGlobalRate: "",
        stoneGlobalCurrency: "USD",
        jewelryGlobalRate: "",
        jewelryGlobalCurrency: "USD",
        jewelryWeightType: "1",
        jewelryChargesType: "1",
      });

      // Open form after fallback data is set
      setShowForm(true);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (isActionLoading) return;
    if (window.confirm("Are you sure?")) {
      setIsActionLoading(true);
      setActionLoadingText("Deleting worker...");
      try {
        await api.workers.delete(id);
        await loadWorkers();
      } catch (error) {
        console.error("Error deleting worker:", error);
      } finally {
        setIsActionLoading(false);
      }
    }
  };

  const handleToggleStatus = async (worker) => {
    if (isActionLoading) return;
    const currentStatus = worker.status ?? 1;
    const newStatus = currentStatus === 1 ? 2 : 1;
    const isActivating = newStatus === 1;
    const actionText = isActivating ? "activate" : "inactivate";
    const workerName = worker.name || worker.worker_name || "this record";

    if (
      window.confirm(
        `Are you sure you want to ${actionText} ${workerName}?`
      )
    ) {
      setIsActionLoading(true);
      setActionLoadingText(
        `${isActivating ? "Activating" : "Inactivating"} worker...`
      );
      try {
        await api.workers.toggleStatus(worker.id, newStatus);
        await loadWorkers();
      } catch (error) {
        console.error(`Error ${actionText}ing worker:`, error);
        alert(error.message || `Failed to ${actionText} worker`);
      } finally {
        setIsActionLoading(false);
      }
    }
  };

  const getShiftName = (shiftId) => {
    if (!shiftId || !Array.isArray(state.shifts)) return "";
    const numericId = parseInt(shiftId, 10);
    const shift = state.shifts.find(
      (shift) => parseInt(shift.id, 10) === numericId,
    );
    return shift
      ? shift.shiftName || shift.name || shift.shift_name || `Shift ${shift.id}`
      : "";
  };

  const getProcessStageName = (stageId) => {
    if (
      !stageId ||
      stageId === -1 ||
      stageId === "-1" ||
      !Array.isArray(state.processStages)
    )
      return "";
    const numericId = parseInt(stageId, 10);
    if (numericId <= 0) return "";
    const stage = state.processStages.find(
      (s) => parseInt(s.id, 10) === numericId,
    );
    return stage ? stage.name || `Stage ${stage.id}` : "";
  };

  const getWorkerTypeDisplay = (worker) => {
    if (!worker) return "-";
    const isEmp =
      worker.type === 2 ||
      worker.type === "2" ||
      worker.type === "employee" ||
      worker.worker_type === 2 ||
      worker.worker_type === "2" ||
      (worker.worker_unid &&
        String(worker.worker_unid).trim().toUpperCase().startsWith("E"));
    if (isEmp) return "Employee";
    if (worker.worker_type === 1 || worker.worker_type === "1") return "Head";
    return "Normal";
  };

  const hasActiveFilters = Object.values(workerFilters).some(
    (value) => value !== "",
  );

  // 1. Initial page load: Load ONLY what is needed for Worker List & Filters (Runs ONCE on mount)
  useEffect(() => {
    if (initialLoadRef.current) return;
    initialLoadRef.current = true;

    if (!state.workers || state.workers.length === 0) {
      loadWorkers();
    }
    if (!state.shifts || state.shifts.length === 0) {
      loadShifts();
    }
  }, [loadWorkers, loadShifts]);

  // 2. Action: Load form master dependencies on-demand when Add / Edit / Copy form opens
  const loadFormData = useCallback(async () => {
    const tasks = [];
    if (!state.processStages?.length) tasks.push(loadProcessStages());
    if (!state.countries?.length) tasks.push(loadCountries());
    if (!state.states?.length) tasks.push(loadStates());
    if (!state.cities?.length) tasks.push(loadCities());
    if (!state.companyIdTypes?.length) tasks.push(loadCompanyIdTypes());
    if (!state.jewelleryGroups?.length) tasks.push(loadJewelleryGroups());
    if (!state.stoneTypes?.length) tasks.push(loadStoneTypes());
    if (!state.currencies?.length) tasks.push(loadCurrencies());
    if (!state.settingTypes?.length) tasks.push(loadSettingTypes());
    if (!state.shifts?.length) tasks.push(loadShifts());
    if (!paymentTerms?.length) {
      tasks.push(
        api.paymentTerms
          .getAll()
          .then((terms) => setPaymentTerms(Array.isArray(terms) ? terms : []))
          .catch((error) => console.error("Error loading payment terms:", error))
      );
    }
    if (tasks.length > 0) {
      await Promise.all(tasks);
    }
  }, [
    state.processStages,
    state.countries,
    state.states,
    state.cities,
    state.companyIdTypes,
    state.jewelleryGroups,
    state.stoneTypes,
    state.currencies,
    state.settingTypes,
    paymentTerms,
    loadProcessStages,
    loadCountries,
    loadStates,
    loadCities,
    loadCompanyIdTypes,
    loadJewelleryGroups,
    loadStoneTypes,
    loadCurrencies,
    loadSettingTypes,
  ]);

  // 3. Action: Load info modal dependencies on-demand when View Details opens
  const loadInfoModalData = useCallback(async () => {
    const tasks = [];
    if (!state.processStages?.length) tasks.push(loadProcessStages());
    if (!state.companyIdTypes?.length) tasks.push(loadCompanyIdTypes());
    if (!state.countries?.length) tasks.push(loadCountries());
    if (!state.states?.length) tasks.push(loadStates());
    if (!state.cities?.length) tasks.push(loadCities());
    if (!state.settingTypes?.length) tasks.push(loadSettingTypes());
    if (tasks.length > 0) {
      await Promise.all(tasks);
    }
  }, [
    state.processStages,
    state.companyIdTypes,
    state.countries,
    state.states,
    state.cities,
    state.settingTypes,
    loadProcessStages,
    loadCompanyIdTypes,
    loadCountries,
    loadStates,
    loadCities,
    loadSettingTypes,
  ]);

  // Trigger loading only when form or info modal is actually opened
  useEffect(() => {
    if (showForm) {
      loadFormData();
    }
  }, [showForm, loadFormData]);

  useEffect(() => {
    if (showInfoModal) {
      loadInfoModalData();
    }
  }, [showInfoModal, loadInfoModalData]);

  const canViewSalary = hasPermission(MODULES.WORKERS, ACTIONS.VIEW_SALARY);

  const workerTableColumns = (() => {
    const columns = [
      {
        key: "worker_unid",
        label: "Worker Id",
        sortable: true,
        sortKey: "worker_unid",
        render: (worker) => worker.worker_unid || "-",
      },
      {
        key: "name",
        label: "Worker/Employee Name",
        sortable: true,
        sortKey: "worker_name",
        render: (worker) => worker.name || "-",
      },
      {
        key: "image",
        label: "Image",
        render: (worker) =>
          worker.images && worker.images.length > 0 ? (
            <img
              src={API_BASE_URL + worker.images[0].url}
              alt={worker.name}
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => openImageModal(worker.images, 0)}
              onError={(e) => {
                e.target.src =
                  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="50" height="50"%3E%3Crect fill="%23ddd" width="50" height="50"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999" font-size="10"%3ENo Image%3C/text%3E%3C/svg%3E';
              }}
            />
          ) : (
            <span className="text-muted">-</span>
          ),
      },
      {
        key: "aliasName",
        label: "Alias Name",
        sortable: true,
        sortKey: "alias_name",
        render: (worker) => worker.aliasName || "-",
      },
      {
        key: "email",
        label: "Email",
        sortable: true,
        sortKey: "email",
        render: (worker) => worker.email || "-",
      },
      {
        key: "contactNo",
        label: "Contact",
        sortable: true,
        sortKey: "phone_no",
        render: (worker) => worker.contactNo || "-",
      },
      {
        key: "department",
        label: "Department",
        sortable: true,
        sortKey: "department",
        render: (worker) => worker.department || "-",
      },
      {
        key: "position",
        label: "Position",
        sortable: true,
        sortKey: "position",
        render: (worker) => worker.position || "-",
      },
      {
        key: "type",
        label: "Type",
        sortable: true,
        sortKey: "worker_type",
        render: (worker) => getWorkerTypeDisplay(worker),
      },
      {
        key: "status",
        label: "Status",
        sortable: true,
        sortKey: "status",
        render: (worker) => (
          (worker.status ?? 1) === 1 ? (
            <span
              className="badge bg-success"
              style={{ fontSize: "11px", padding: "4px 8px" }}
            >
              Active
            </span>
          ) : (
            <span
              className="badge bg-danger"
              style={{ fontSize: "11px", padding: "4px 8px" }}
            >
              Inactive
            </span>
          )
        ),
      },
      {
        key: "shift",
        label: "Shift",
        render: (worker) => getShiftName(worker.shiftId) || "-",
      },
    ];

    if (canViewSalary) {
      columns.push({
        key: "salary",
        label: "Salary",
        sortable: true,
        sortKey: "monthly_salary",
        render: (worker) => `₹${worker.salary || 0}`,
      });
    }

    columns.push({
      key: "joinDate",
      label: "Join Date",
      sortable: true,
      sortKey: "joining_date",
      render: (worker) => worker.joinDate || "-",
    });

    return columns;
  })();

  const renderWorkerTableActions = (worker) => {
    const isActive = (worker.status ?? 1) === 1;

    return (
      <>
        <PermissionGuard module={MODULES.WORKERS} action={ACTIONS.VIEW}>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleInfo(worker)}
            disabled={isActionLoading}
            style={{ fontSize: "13px", padding: "4px 10px" }}
            title="View Details"
          >
            <i className="bi bi-info-circle-fill"></i>
          </button>
        </PermissionGuard>
        {isActive && (
          <>
            <PermissionGuard module={MODULES.WORKERS} action={ACTIONS.EDIT}>
              <button
                title="Edit"
                className="btn btn-sm btn-primary"
                onClick={() => handleEdit(worker)}
                disabled={isActionLoading}
                style={{ fontSize: "13px", padding: "4px 10px" }}
              >
                <i className="bi bi-pencil-square"></i>
              </button>
            </PermissionGuard>
            <PermissionGuard module={MODULES.WORKERS} action={ACTIONS.CREATE}>
              <button
                className="btn btn-sm btn-primary"
                onClick={() => handleCopy(worker)}
                disabled={isActionLoading}
                style={{ fontSize: "13px", padding: "4px 10px" }}
                title="Copy Worker"
              >
                <i className="fa-solid fa-copy"></i>
              </button>
            </PermissionGuard>
          </>
        )}
        {/* Hard delete commented out as per soft delete requirement
        <PermissionGuard module={MODULES.WORKERS} action={ACTIONS.DELETE}>
          <button
            title="Delete"
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(worker.id)}
            disabled={isActionLoading}
            style={{ fontSize: "13px", padding: "4px 10px" }}
          >
            <i className="bi bi-trash-fill"></i>
          </button>
        </PermissionGuard>
        */}
        <button
          title={isActive ? "Inactivate Worker" : "Activate Worker"}
          className={`btn btn-sm ${isActive ? "btn-outline-danger" : "btn-outline-success"}`}
          onClick={() => handleToggleStatus(worker)}
          disabled={isActionLoading}
          style={{ fontSize: "13px", padding: "4px 10px" }}
        >
          {isActive ? (
            <i className="bi bi-person-x-fill" title="Inactivate"></i>
          ) : (
            <i className="bi bi-person-check-fill" title="Activate"></i>
          )}
        </button>
      </>
    );
  };

  const isTypeDisabledOnEdit = Boolean(editingWorker);
  const isRegisteredWorker = Boolean(
    editingWorker && Number(editingWorker.registered) === 1
  );
  const isEditingEmployee = Boolean(
    editingWorker &&
    (editingWorker.type === 2 ||
      editingWorker.type === "2" ||
      editingWorker.type === "employee" ||
      editingWorker.worker_type === 2 ||
      editingWorker.worker_type === "2" ||
      (editingWorker.worker_unid &&
        String(editingWorker.worker_unid)
          .trim()
          .toUpperCase()
          .startsWith("E")))
  );

  return (
    <div className="Workers">
      {/* Full-screen blocking loader when action is triggered */}
      {isActionLoading && (
        <div
          className="full-screen-action-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            inset: 0,
            width: "100%",
            height: "100%",
            minWidth: "100%",
            minHeight: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            backdropFilter: "blur(2px)",
            WebkitBackdropFilter: "blur(2px)",
            zIndex: 999999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "all",
            cursor: "wait",
          }}
        >
          <div
            className="full-screen-action-card"
            style={{
              background: "#ffffff",
              padding: "18px 28px",
              borderRadius: "8px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.25)",
              display: "flex",
              alignItems: "center",
              gap: "14px",
              pointerEvents: "auto",
            }}
          >
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "2rem", height: "2rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <span
              className="full-screen-action-text"
              style={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#212529",
                letterSpacing: "0.2px",
              }}
            >
              {actionLoadingText || "Loading..."}
            </span>
          </div>
        </div>
      )}
      {message.text && (
        <Message
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: "", type: "" })}
        />
      )}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h2 className="hd_a">
          Workers ({workersTableTotal}
          {hasActiveFilters && Array.isArray(state.workers)
            ? ` / ${state.workers.length}`
            : ""}
          )
        </h2>
        <div className="d-flex align-items-center gap-2">
          {/* <button
            className="btn btn-outline-secondary me-2"
            onClick={loadWorkers}
            title="Refresh"
          >
            🔄 Refresh
          </button> */}
          <button
            type="button"
            className={`btn ${hasActiveFilters ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setShowFilters((prev) => !prev)}
            title="Filter Workers"
          >
            <i className="bi bi-funnel"></i>
          </button>
          <PermissionGuard module={MODULES.WORKERS} action={ACTIONS.CREATE}>
            <button
              className="btn btn-primary"
              onClick={async () => {
                setShowForm(true);
                setWorkerType("worker");
                setWorkerCategory("0");
                try {
                  const response = await api.workers.getNextUnid("worker");
                  setFormData({ ...emptyForm, worker_unid: response.nextUnid });
                } catch (error) {
                  setFormData(emptyForm);
                }
              }}
            >
              <i className="bi bi-plus-lg me-1"></i>Add Worker
            </button>
          </PermissionGuard>
        </div>
      </div>

      {showFilters && (
        <div className="card shadow-sm mb-3">
          <div className="card-body py-3">
            <div className="d-flex flex-wrap align-items-end gap-3">
              <div style={{ minWidth: "240px", flex: "1 1 240px" }}>
                <label className="form-label mb-1">Worker/Employee Name</label>
                <select
                  className="form-control"
                  value={workerFilters.worker_id}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const matched = (state.workers || []).find((w) => String(w.id) === String(selectedId));
                    const cleanName = matched?.worker_name || matched?.name?.replace(/\s*\((sigi|sigipro|hrms user)\)$/i, '') || "";
                    setWorkerFilters((prev) => ({
                      ...prev,
                      worker_id: selectedId,
                      worker_name: cleanName,
                    }));
                  }}
                >
                  <option value="">All Workers</option>

                  {(state.workers || [])
                    .filter((w) => !String(w.id).startsWith("user_"))
                    .map((worker) => (
                      <option key={worker.id} value={worker.id}>
                        {worker.name}
                      </option>
                    ))}
                </select>
              </div>
              <div style={{ minWidth: "240px", flex: "1 1 240px" }}>
                <label className="form-label mb-1">Contact No</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by contact number"
                  value={workerFilters.contact_no}
                  onChange={(e) =>
                    setWorkerFilters((prev) => ({
                      ...prev,
                      contact_no: e.target.value,
                    }))
                  }
                />
              </div>
              <div style={{ minWidth: "220px", flex: "1 1 220px" }}>
                <label className="form-label mb-1">Shift</label>
                <select
                  className="form-select"
                  value={workerFilters.shiftId}
                  onChange={(e) =>
                    setWorkerFilters((prev) => ({
                      ...prev,
                      shiftId: e.target.value,
                    }))
                  }
                >
                  <option value="">All Shifts</option>
                  {(Array.isArray(state.shifts) ? state.shifts : []).map(
                    (shift) => (
                      <option key={shift.id} value={shift.id}>
                        {shift.shiftName ||
                          shift.name ||
                          shift.shift_name ||
                          `Shift ${shift.id}`}
                      </option>
                    ),
                  )}
                </select>
              </div>
              <div
                className="d-flex align-items-end"
                style={{ minWidth: "120px" }}
              >
                <button
                  type="button"
                  className="btn btn-outline-primary w-100"
                  onClick={() =>
                    setWorkerFilters({
                      worker_id: "",
                      worker_name: "",
                      contact_no: "",
                      shiftId: "",
                    })
                  }
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showForm && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", pointerEvents: isSavingWorker ? "none" : "auto" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{ backgroundColor: "#f0f4fb", padding: "8px 16px" }}
              >
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h5 className="modal-title">
                    {editingWorker ? "Edit Worker/Employee" : "Add New Worker/Employee"}
                  </h5>

                  {workerType === "worker" && (
                    <div className="d-flex align-items-center gap-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="workerCategory"
                          id="normalWorkerRadio"
                          value="0"
                          checked={workerCategory === "0"}
                          disabled={isSavingWorker || isRegisteredWorker}
                          onChange={(e) => {
                            if (isRegisteredWorker) return;
                            setWorkerCategory(e.target.value);
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="normalWorkerRadio"
                          style={{
                            cursor: isRegisteredWorker ? "not-allowed" : "pointer",
                            opacity: isRegisteredWorker ? 0.65 : 1
                          }}
                        >
                          Normal Worker
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="workerCategory"
                          id="headWorkerRadio"
                          value="1"
                          checked={workerCategory === "1"}
                          disabled={isSavingWorker || isRegisteredWorker}
                          onChange={(e) => {
                            if (isRegisteredWorker) return;
                            setWorkerCategory(e.target.value);
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="headWorkerRadio"
                          style={{
                            cursor: isRegisteredWorker ? "not-allowed" : "pointer",
                            opacity: isRegisteredWorker ? 0.65 : 1
                          }}
                        >
                          Head Worker
                        </label>
                      </div>
                    </div>
                  )}

                  <div className="d-flex align-items-center gap-3">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="workerType"
                        id="workerRadio"
                        value="worker"
                        checked={workerType === "worker"}
                        disabled={isSavingWorker || isTypeDisabledOnEdit || isRegisteredWorker}
                        onChange={async (e) => {
                          if (isTypeDisabledOnEdit || isRegisteredWorker) return;
                          const newType = e.target.value;
                          setWorkerType(newType);
                          setActiveTab("personal");
                          if (!editingWorker) {
                            try {
                              const res = await api.workers.getNextUnid("worker");
                              if (res && res.nextUnid) {
                                setFormData((prev) => ({
                                  ...prev,
                                  worker_unid: res.nextUnid,
                                }));
                              }
                            } catch (err) {
                              console.error("Error fetching worker UNID:", err);
                            }
                          }
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="workerRadio"
                        style={{
                          cursor: (isTypeDisabledOnEdit || isRegisteredWorker) ? "not-allowed" : "pointer",
                          opacity: (isTypeDisabledOnEdit || isRegisteredWorker) ? 0.65 : 1
                        }}
                      >
                        Worker
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="workerType"
                        id="employeeRadio"
                        value="employee"
                        checked={workerType === "employee"}
                        disabled={isSavingWorker || isTypeDisabledOnEdit || isRegisteredWorker}
                        onChange={async (e) => {
                          if (isTypeDisabledOnEdit || isRegisteredWorker) return;
                          const newType = e.target.value;
                          setWorkerType(newType);
                          setActiveTab("personal");
                          if (!editingWorker) {
                            try {
                              const res = await api.workers.getNextUnid("employee");
                              if (res && res.nextUnid) {
                                setFormData((prev) => ({
                                  ...prev,
                                  worker_unid: res.nextUnid,
                                }));
                              }
                            } catch (err) {
                              console.error("Error fetching employee UNID:", err);
                            }
                          }
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="employeeRadio"
                        style={{
                          cursor: (isTypeDisabledOnEdit || isRegisteredWorker) ? "not-allowed" : "pointer",
                          opacity: (isTypeDisabledOnEdit || isRegisteredWorker) ? 0.65 : 1
                        }}
                      >
                        Employee
                      </label>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <h5>
                      {formData.worker_unid && (
                        <span
                          className="ms-3 text-muted"
                          style={{ fontSize: "14px" }}
                        >
                          {workerType === "employee" ? "Employee Id: " : "Worker Id: "}
                          {formData.worker_unid}
                        </span>
                      )}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      disabled={isSavingWorker}
                      onClick={() => {
                        if (isSavingWorker) return;
                        setShowForm(false);
                        setEditingWorker(null);
                        setFormData(emptyForm);
                        setActiveTab("personal");
                        setAddressRows([{ id: 1 }]);
                        setIdRows([{ id: 1 }]);
                        setWorkerImages([]);
                        setWorkerPdfs([]);
                        setIdDocuments({});
                        closeDuplicateModal();
                      }}
                    ></button>
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                <input
                  type="hidden"
                  name="workerType"
                  value={
                    isEditingEmployee
                      ? "employee"
                      : isTypeDisabledOnEdit
                        ? "worker"
                        : workerType
                  }
                />
                <input
                  type="hidden"
                  name="workerCategory"
                  value={
                    isRegisteredWorker
                      ? String(editingWorker?.worker_type ?? "0")
                      : isEditingEmployee
                        ? "2"
                        : workerCategory
                  }
                />
                <input
                  type="hidden"
                  name="type"
                  value={
                    isEditingEmployee
                      ? "employee"
                      : isTypeDisabledOnEdit
                        ? "worker"
                        : workerType
                  }
                />
                <input
                  type="hidden"
                  name="worker_type"
                  value={
                    isRegisteredWorker
                      ? String(editingWorker?.worker_type ?? "0")
                      : isEditingEmployee
                        ? "2"
                        : String(workerCategory)
                  }
                />
                <div className="modal-body">
                  {/* Tab Navigation */}
                  <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "personal" ? "active" : ""
                          }`}
                        onClick={() => setActiveTab("personal")}
                      >
                        <i className="bi bi-person-circle me-2"></i>Personal
                        Info
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "account" ? "active" : ""
                          }`}
                        onClick={() => setActiveTab("account")}
                      >
                        <i className="bi bi-bank2 me-2"></i>Account Info
                      </button>
                    </li>
                    {workerType === "worker" && (
                      <PermissionGuard
                        module={MODULES.WORKERS}
                        action={ACTIONS.VIEW_SALARY}
                      >
                        <li className="nav-item">
                          <button
                            type="button"
                            className={`nav-link ${activeTab === "price" ? "active" : ""
                              }`}
                            onClick={() => setActiveTab("price")}
                          >
                            <i className="bi bi-currency-dollar me-2"></i>Price
                            Criteria
                          </button>
                        </li>
                      </PermissionGuard>
                    )}
                  </ul>

                  {/* Personal Info Tab */}
                  {activeTab === "personal" && (
                    <div className="row ">
                      <div className="col-md-2 position-relative">
                        <label className="form-label">
                          Worker/Employee Name *
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          value={formData.worker_name}
                          autoComplete="off"
                          onChange={(e) => {
                            const value = e.target.value;

                            setFormData({
                              ...formData,
                              worker_name: value,
                            });

                            if (value.trim() !== "") {
                              const matchedWorkers = (
                                state.workers || []
                              ).filter((worker) =>
                                (worker.name || "")
                                  .toLowerCase()
                                  .includes(value.toLowerCase()),
                              );

                              setWorkerNameSuggestions(matchedWorkers);
                              setShowWorkerSuggestions(true);
                            } else {
                              setWorkerNameSuggestions([]);
                              setShowWorkerSuggestions(false);
                            }
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setShowWorkerSuggestions(false);
                            }, 200);
                          }}
                          required
                        />

                        {showWorkerSuggestions &&
                          workerNameSuggestions.length > 0 && (
                            <div
                              className="border bg-white position-absolute w-100 shadow-sm"
                              style={{
                                zIndex: 9999,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {workerNameSuggestions.map((worker) => (
                                <div
                                  key={worker.id}
                                  className="p-2 border-bottom"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      worker_name: worker.name || "",
                                      //phone_no: worker.contactNo || "",
                                    });

                                    setShowWorkerSuggestions(false);
                                  }}
                                >
                                  <div>
                                    <strong>{worker.name}</strong>
                                  </div>

                                  {/* <small className="text-muted">
                                    {worker.contactNo || ""}
                                  </small> */}
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Alias Name *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.alias_name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              alias_name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>





                      {/*  <div className="col-md-2">
                        <label className="form-label">Contact No. *</label>
                        <input
                          type="number"
                          className="form-control"
                          value={formData.phone_no}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              phone_no: e.target.value,
                            })
                          }
                          required
                        />
                      </div>*/}

                      <div className="col-md-2 position-relative">
                        <label className="form-label">Contact No. *</label>

                        <input
                          type="number"
                          className="form-control"
                          autoComplete="off"
                          value={formData.phone_no}
                          onChange={(e) => {
                            const value = e.target.value;

                            setFormData({
                              ...formData,
                              phone_no: value,
                            });

                            if (value.trim() !== "") {
                              const matchedContacts = (state.workers || []).filter((worker) =>
                                String(worker.contactNo || "")
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );

                              setContactSuggestions(matchedContacts);
                              setShowContactSuggestions(true);
                            } else {
                              setContactSuggestions([]);
                              setShowContactSuggestions(false);
                            }
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setShowContactSuggestions(false);
                            }, 200);
                          }}
                          required
                        />

                        {showContactSuggestions &&
                          contactSuggestions.length > 0 && (
                            <div
                              className="border bg-white position-absolute w-100 shadow-sm"
                              style={{
                                zIndex: 9999,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {contactSuggestions.map((worker) => (
                                <div
                                  key={worker.id}
                                  className="p-2 border-bottom"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      phone_no: worker.contactNo || "",
                                      worker_name: worker.name || formData.worker_name,
                                      email: worker.email || formData.email,
                                    });

                                    setShowContactSuggestions(false);
                                  }}
                                >
                                  <div>
                                    <strong>{worker.contactNo}</strong>
                                  </div>

                                  {/* <small className="text-muted">
              {worker.name || ""}
            </small> */}
                                </div>
                              ))}
                            </div>
                          )}
                      </div>


                      {/* <div className="col-md-2">
                        <label className="form-label">Email Id</label>
                        <input
                          type="email"
                          className="form-control"
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                        />
                      </div> */}

                      <div className="col-md-2 position-relative">
                        <label className="form-label">Email Id</label>

                        <input
                          type="email"
                          className="form-control"
                          autoComplete="off"
                          value={formData.email}
                          onChange={(e) => {
                            const value = e.target.value;

                            setFormData({
                              ...formData,
                              email: value,
                            });

                            if (value.trim() !== "") {
                              const matchedEmails = (
                                state.workers || []
                              ).filter((worker) =>
                                (worker.email || "")
                                  .toLowerCase()
                                  .includes(value.toLowerCase()),
                              );

                              setEmailSuggestions(matchedEmails);
                              setShowEmailSuggestions(true);
                            } else {
                              setEmailSuggestions([]);
                              setShowEmailSuggestions(false);
                            }
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setShowEmailSuggestions(false);
                            }, 200);
                          }}
                        />

                        {showEmailSuggestions &&
                          emailSuggestions.length > 0 && (
                            <div
                              className="border bg-white position-absolute w-100 shadow-sm"
                              style={{
                                zIndex: 9999,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {emailSuggestions.map((worker) => (
                                <div
                                  key={worker.id}
                                  className="p-2 border-bottom"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      email: worker.email || "",
                                      worker_name:
                                        worker.name || formData.worker_name,
                                      phone_no:
                                        worker.contactNo || formData.phone_no,
                                    });

                                    setShowEmailSuggestions(false);
                                  }}
                                >
                                  <div>
                                    <strong>{worker.email}</strong>
                                  </div>

                                  <small className="text-muted">
                                    {worker.name || ""}
                                  </small>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                      {/* <div className="col-md-4">
                        <label className="form-label">Website</label>
                        <input
                          type="url"
                          className="form-control"
                          value={formData.website}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              website: e.target.value,
                            })
                          }
                        />
                      </div> */}
                      <div className="col-md-2">
                        <label className="form-label">Joining Date</label>
                        <DatePicker
                          value={formData.joining_date}
                          onChange={(date) =>
                            setFormData({ ...formData, joining_date: date })
                          }
                          placeholder="Select joining date"
                        />
                      </div>
                      {/* <div className="col-md-2">
                        <label className="form-label">Department *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.department}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              department: e.target.value,
                            })
                          }
                          required
                        />
                      </div> */}

                      <div className="col-md-2 position-relative">
                        <label className="form-label">Department *</label>

                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          value={formData.department}
                          onChange={(e) => {
                            const value = e.target.value;

                            setFormData({
                              ...formData,
                              department: value,
                            });

                            if (value.trim() !== "") {
                              const uniqueDepartments = [
                                ...new Set(
                                  (state.workers || [])
                                    .map((worker) => worker.department)
                                    .filter(Boolean),
                                ),
                              ];

                              const matchedDepartments =
                                uniqueDepartments.filter((department) =>
                                  department
                                    .toLowerCase()
                                    .includes(value.toLowerCase()),
                                );

                              setDepartmentSuggestions(matchedDepartments);
                              setShowDepartmentSuggestions(true);
                            } else {
                              setDepartmentSuggestions([]);
                              setShowDepartmentSuggestions(false);
                            }
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setShowDepartmentSuggestions(false);
                            }, 200);
                          }}
                          required
                        />

                        {showDepartmentSuggestions &&
                          departmentSuggestions.length > 0 && (
                            <div
                              className="border bg-white position-absolute w-100 shadow-sm"
                              style={{
                                zIndex: 9999,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {departmentSuggestions.map(
                                (department, index) => (
                                  <div
                                    key={index}
                                    className="p-2 border-bottom"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setFormData({
                                        ...formData,
                                        department: department || "",
                                      });

                                      setShowDepartmentSuggestions(false);
                                    }}
                                  >
                                    <strong>{department}</strong>
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                      </div>
                      {/* <div className="col-md-2">
                        <label className="form-label">Position *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.position}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              position: e.target.value,
                            })
                          }
                          required
                        />
                      </div> */}

                      <div className="col-md-2 position-relative">
                        <label className="form-label">Position *</label>

                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          value={formData.position}
                          onChange={(e) => {
                            const value = e.target.value;

                            setFormData({
                              ...formData,
                              position: value,
                            });

                            if (value.trim() !== "") {
                              const uniquePositions = [
                                ...new Set(
                                  (state.workers || [])
                                    .map((worker) => worker.position)
                                    .filter(Boolean),
                                ),
                              ];

                              const matchedPositions = uniquePositions.filter(
                                (position) =>
                                  position
                                    .toLowerCase()
                                    .includes(value.toLowerCase()),
                              );

                              setPositionSuggestions(matchedPositions);
                              setShowPositionSuggestions(true);
                            } else {
                              setPositionSuggestions([]);
                              setShowPositionSuggestions(false);
                            }
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setShowPositionSuggestions(false);
                            }, 200);
                          }}
                          required
                        />

                        {showPositionSuggestions &&
                          positionSuggestions.length > 0 && (
                            <div
                              className="border bg-white position-absolute w-100 shadow-sm"
                              style={{
                                zIndex: 9999,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {positionSuggestions.map((position, index) => (
                                <div
                                  key={index}
                                  className="p-2 border-bottom"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      position: position || "",
                                    });

                                    setShowPositionSuggestions(false);
                                  }}
                                >
                                  <strong>{position}</strong>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">Shift *</label>
                        <select
                          className="form-control"
                          value={formData.shiftId}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              shiftId: e.target.value,
                            })
                          }
                          required
                        >
                          <option value="">Select Shift</option>
                          {(Array.isArray(state.shifts)
                            ? state.shifts
                            : []
                          )
                            .filter(
                              (shift) =>
                                (shift.status ?? 1) === 1 ||
                                String(shift.id) === String(formData.shiftId)
                            )
                            .map((shift) => (
                            <option key={shift.id} value={shift.id}>
                              {shift.shiftName ||
                                shift.name ||
                                `Shift ${shift.id}`}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Notice Period(Days)</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          value={formData.notice_period}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || parseFloat(value) >= 0) {
                              setFormData({
                                ...formData,
                                notice_period: value,
                              });
                            }
                          }}
                        />
                      </div>
                      {/* <div className="col-md-2">
                        <label className="form-label">Period Type</label>
                        <select
                          className="form-control"
                          value={formData.noticePeriodType}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              noticePeriodType: e.target.value,
                            })
                          }
                        >
                          <option value="month">month</option>
                          <option value="Months">Months</option>
                        </select>
                      </div> */}
                      <PermissionGuard
                        module={MODULES.WORKERS}
                        action={ACTIONS.VIEW_SALARY}
                      >
                        <div className="col-md-2">
                          <label className="form-label">Salary Type</label>
                          <select
                            className="form-control"
                            value={formData.salary_type}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                salary_type: e.target.value,
                              })
                            }
                          >
                            <option value="salary">Salary</option>
                            <option value="pcs">PCS</option>
                            <option value="both">Both</option>
                          </select>
                        </div>
                        <div className="col-md-2">
                          <label className="form-label">Monthly Salary</label>
                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            value={formData.monthly_salary}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || parseFloat(value) >= 0) {
                                setFormData({
                                  ...formData,
                                  monthly_salary: value,
                                });
                              }
                            }}
                          />
                        </div>
                      </PermissionGuard>
                      <div className="col-md-2">
                        <label className="form-label">Allowed Loss Wt</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          step="0.01"
                          value={formData.allowed_fine_wt}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              allowed_fine_wt: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Commission %</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          max="100"
                          step="0.01"
                          value={formData.commission_percentage}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              commission_percentage: e.target.value,
                            })
                          }
                        />
                      </div>
                      {/* <div className="col-md-2">
                        <label className="form-label">Bonus %</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          max="100"
                          step="0.01"
                          value={formData.bonus_percentage}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              bonus_percentage: e.target.value,
                            })
                          }
                        />
                      </div> */}
                      <div className="col-md-2">
                        <label className="form-label">Bonus Amount</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          step="0.01"
                          value={formData.bonus_amount}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              bonus_amount: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Bonus Installment</label>
                        <select
                          className="form-control"
                          value={formData.bonus_installment || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              bonus_installment: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Payment Term</option>
                          {paymentTerms.filter((term) => (term.status ?? 1) === 1 || String(term.id) === String(formData.bonus_installment)).map((term) => (
                            <option key={term.id} value={term.id}>
                              {term.title} (
                              {Array.isArray(term.installments)
                                ? term.installments
                                  .map(
                                    (inst) =>
                                      `${getOrdinalMonth(inst.installmentMonth || inst.month || inst.days)}: ${inst.paymentPercentage || inst.percentage}%`,
                                  )
                                  .join(", ")
                                : ""}
                              )
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Loan Allowed</label>
                        <select
                          className="form-control"
                          value={formData.loan_allowed ? "yes" : "no"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              loan_allowed: e.target.value === "yes",
                              loan_amount:
                                e.target.value === "no"
                                  ? ""
                                  : formData.loan_amount,
                            })
                          }
                        >
                          <option value="no">No</option>
                          <option value="yes">Yes</option>
                        </select>
                      </div>
                      {formData.loan_allowed && (
                        <>
                          <div className="col-md-2">
                            <label className="form-label">Loan Amount</label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              className="form-control"
                              value={formData.loan_amount || ""}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  loan_amount: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Installment</label>
                            <select
                              className="form-control"
                              value={formData.loan_installment_id || ""}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  loan_installment_id: e.target.value,
                                })
                              }
                            >
                              <option value="">Select Payment Term</option>
                              {paymentTerms.filter((term) => (term.status ?? 1) === 1 || String(term.id) === String(formData.loan_installment_id)).map((term) => (
                                <option key={term.id} value={term.id}>
                                  {term.title} (
                                  {Array.isArray(term.installments)
                                    ? term.installments
                                      .map(
                                        (inst) =>
                                          `${getOrdinalMonth(inst.installmentMonth || inst.month || inst.days)}: ${inst.paymentPercentage || inst.percentage}%`,
                                      )
                                      .join(", ")
                                    : ""}
                                  )
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                      {workerType === "worker" && (
                        <div className="col-md-2">
                          <label className="form-label">Process Stages</label>
                          <select
                            className="form-select"
                            value={formData.process_stage_id}
                            required
                            onChange={(event) =>
                              setFormData({
                                ...formData,
                                process_stage_id: event.target.value,
                              })
                            }
                          >
                            <option value="">Select Process Stage</option>
                            {(Array.isArray(state.processStages)
                              ? state.processStages
                              : []
                            ).map((stage) => (
                              <option key={stage.id} value={stage.id}>
                                {stage.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      <div className="col-md-3">
                        <label className="form-label">Worker Rating</label>
                        <div className="d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger me-2"
                            title="Reset Rating"
                            onClick={() =>
                              setFormData({ ...formData, rating: 0 })
                            }
                          >
                            <i className="bi bi-arrow-counterclockwise"></i>
                          </button>

                          {[1, 2, 3, 4, 5].map((star) => (
                            <button
                              key={star}
                              type="button"
                              className={`btn btn-sm me-1 ${formData.rating >= star
                                ? "btn-warning"
                                : "btn-outline-secondary"
                                }`}
                              onClick={() =>
                                setFormData({ ...formData, rating: star })
                              }
                            >
                              ⭐
                            </button>
                          ))}

                          <span className="ms-2">{formData.rating}/5</span>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Upload Images</label>
                        <FileUpload
                          onFileUploaded={(files) => {
                            const newFiles = Array.isArray(files)
                              ? files
                              : [files];
                            setWorkerImages((prev) => [...prev, ...newFiles]);
                          }}
                          accept="image/*"
                          multiple={true}
                          buttonText="Add Image"
                          buttonClass="btn btn-primary btn-sm"
                        />
                        {workerImages.length > 0 && (
                          <div className="mt-2">
                            <small className="text-muted">
                              Uploaded Images:
                            </small>
                            <div className="row g-2 mt-1">
                              {workerImages.map((image, index) => (
                                <div key={image.id || index} className="col-4">
                                  <div className="position-relative">
                                    <img
                                      src={`${process.env.REACT_APP_API_URL + image.url}`}
                                      alt={
                                        image.originalName ||
                                        `Image ${index + 1}`
                                      }
                                      className="img-thumbnail"
                                      style={{
                                        width: "100%",
                                        height: "80px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        openImageModal(workerImages, index)
                                      }
                                      onError={(e) => {
                                        console.error(
                                          "Image load error:",
                                          image,
                                        );
                                        e.target.src =
                                          'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23ddd" width="100" height="100"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3ENo Image%3C/text%3E%3C/svg%3E';
                                      }}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                      style={{
                                        padding: "2px 6px",
                                        fontSize: "10px",
                                      }}
                                      onClick={() =>
                                        setWorkerImages((prev) =>
                                          prev.filter((_, i) => i !== index),
                                        )
                                      }
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Upload PDFs</label>
                        <FileUpload
                          onFileUploaded={(files) => {
                            const newFiles = Array.isArray(files)
                              ? files
                              : [files];
                            console.log("PDF uploaded:", newFiles);
                            setWorkerPdfs((prev) => {
                              const updated = [...prev, ...newFiles];
                              console.log("Updated workerPdfs:", updated);
                              return updated;
                            });
                          }}
                          accept=".pdf"
                          multiple={true}
                          buttonText="Add PDF"
                          buttonClass="btn btn-success btn-sm"
                        />
                        {workerPdfs.length > 0 && (
                          <div className="mt-2">
                            <small className="text-muted">Uploaded PDFs:</small>
                            <div className="mt-1">
                              {workerPdfs.map((pdf, index) => (
                                <div
                                  key={pdf.id || index}
                                  className="d-flex align-items-center justify-content-between mb-1 p-1 border rounded"
                                >
                                  <small
                                    className="text-truncate"
                                    style={{
                                      maxWidth: "150px",
                                      cursor: "pointer",
                                      color: "#0d6efd",
                                    }}
                                    onClick={() => {
                                      if (pdf && pdf.url) {
                                        window.open(
                                          `${process.env.REACT_APP_API_URL + pdf.url}`,
                                          "_blank",
                                        );
                                      }
                                    }}
                                  >
                                    📄 {pdf.originalName || `PDF ${index + 1}`}
                                  </small>
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    style={{
                                      padding: "2px 6px",
                                      fontSize: "10px",
                                    }}
                                    onClick={() =>
                                      setWorkerPdfs((prev) =>
                                        prev.filter((_, i) => i !== index),
                                      )
                                    }
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-12">
                        <div className="border rounded mt-4">
                          <h6 className="mb-0 p-3 border-bottom bg-light pt-2 pr-0 pb-2">
                            Postal Address
                          </h6>
                          <div className="p-2">
                            <div className="table-responsive">
                              <table className="table table-bordered mb-0">
                                <thead className="table-light">
                                  <tr>
                                    {/* <th style={{ width: "100px" }}>#</th> */}
                                    {/* <th style={{ width: "100px" }}>Type</th> */}
                                    <th style={{ width: "200px" }}>
                                      Address Line 1
                                    </th>
                                    <th style={{ width: "200px" }}>
                                      Address Line 2
                                    </th>

                                    <th style={{ width: "150px" }}>Country</th>

                                    <th style={{ width: "150px" }}>State</th>
                                    <th style={{ width: "150px" }}>City</th>
                                    <th style={{ width: "120px" }}>Zip Code</th>
                                    <th style={{ width: "60px" }}></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {addressRows.map((row, index) => (
                                    <tr key={row.id}>
                                      {/* <td>
                                       <select
                                          className="form-control form-control-sm"
                                          value={
                                            formData[`address_type${row.id}`] ||
                                            "Shipping"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`address_type${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                        >
                                          <option value="Shipping">
                                            Shipping
                                          </option>
                                          <option value="Billing">
                                            Billing
                                          </option>
                                        </select>
                                      </td> */}
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          value={
                                            formData[
                                            `address_line1${row.id}`
                                            ] || ""
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`address_line1${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                          placeholder="Address Line 1"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          value={
                                            formData[
                                            `address_line2${row.id}`
                                            ] || ""
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`address_line2${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                          placeholder="Address Line 2"
                                        />
                                      </td>
                                      <td>
                                        <select
                                          className="form-control form-control-sm"
                                          value={
                                            formData[`country_id${row.id}`] ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`country_id${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                        >
                                          <option value="">
                                            Select Country
                                          </option>
                                          {(Array.isArray(state.countries)
                                            ? state.countries
                                            : []
                                          ).map((country) => (
                                            <option
                                              key={country.id}
                                              value={country.id}
                                            >
                                              {country.name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          className="form-control form-control-sm"
                                          value={
                                            formData[`state_id${row.id}`] || ""
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`state_id${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                        >
                                          <option value="">Select State</option>
                                          {(Array.isArray(state.states)
                                            ? state.states
                                            : []
                                          ).map((stateItem) => (
                                            <option
                                              key={stateItem.id}
                                              value={stateItem.id}
                                            >
                                              {stateItem.name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          className="form-control form-control-sm"
                                          value={
                                            formData[`city_id${row.id}`] || ""
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`city_id${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                        >
                                          <option value="">Select City</option>
                                          {(Array.isArray(state.cities)
                                            ? state.cities
                                            : []
                                          ).map((city) => (
                                            <option
                                              key={city.id}
                                              value={city.id}
                                            >
                                              {city.name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          value={
                                            formData[`zip_code${row.id}`] || ""
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`zip_code${row.id}`]:
                                                e.target.value,
                                            })
                                          }
                                          placeholder="Zip Code"
                                        />
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          style={{
                                            float: "right",
                                          }}
                                          className="btn btn-danger"
                                          onClick={() =>
                                            removeAddressRow(row.id)
                                          }
                                          disabled={addressRows.length === 1}
                                        >
                                          <i class="bi bi-trash-fill"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-3">
                              <button
                                type="button"
                                style={{
                                  float: "right",
                                  marginTop: -18,
                                }}
                                className="btn btn-primary sm-btt"
                                onClick={addAddressRow}
                              >
                                <i class="bi bi-plus-circle-fill"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Reference</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          value={formData.reference}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              reference: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Remarks</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          value={formData.remarks}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              remarks: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  )}

                  {/* Account Info Tab */}
                  {activeTab === "account" && (
                    <div>
                      <div className="border rounded mb-4">
                        <h6 className="mb-0 p-3 border-bottom bg-light pt-2 pr-0 pb-2">
                          Account Basic Info
                        </h6>
                        <div className="p-3">
                          <div className="row g-3">
                            <div className="col-md-4">
                              <label className="form-label">
                                Account/Beneficiary Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.beneficiary_name}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    beneficiary_name: e.target.value,
                                  })
                                }
                                placeholder="Account/Beneficiary Name"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">
                                Account Number
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                value={formData.account_number}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    account_number: e.target.value,
                                  })
                                }
                                placeholder="Account Number"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">Bank Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.bank_name}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    bank_name: e.target.value,
                                  })
                                }
                                placeholder="Bank Name"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">Bank Address</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.bank_address}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    bank_address: e.target.value,
                                  })
                                }
                                placeholder="Bank Address"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">Swift Code</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.swift_code}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    swift_code: e.target.value,
                                  })
                                }
                                placeholder="Swift Code"
                              />
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">IFSC Code</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.ifsc_code}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ifsc_code: e.target.value,
                                  })
                                }
                                placeholder="IFSC Code"
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label">Note's</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={formData.note}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    note: e.target.value,
                                  })
                                }
                                placeholder="Note's"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="border rounded">
                        <h6 className="mb-0 p-3 border-bottom bg-light pt-2 pr-0 pb-2">
                          Personal ID Info
                        </h6>
                        <div className="p-3">
                          <div className="table-responsive">
                            <table className="table table-bordered mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: "30px" }}>#</th>
                                  <th style={{ width: "200px" }}>
                                    Company Id Type
                                  </th>
                                  <th style={{ width: "200px" }}>Number</th>
                                  <th style={{ width: "150px" }}>Upload PDF</th>
                                  <th style={{ width: "60px" }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {idRows.map((row, index) => (
                                  <tr key={row.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <select
                                        className="form-control form-control-sm"
                                        value={
                                          formData[`id_type_id${row.id}`] || ""
                                        }
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            [`id_type_id${row.id}`]:
                                              e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">ID Type</option>
                                        {(Array.isArray(state.companyIdTypes)
                                          ? state.companyIdTypes
                                          : []
                                        ).map((idType) => (
                                          <option
                                            key={idType.id}
                                            value={idType.id}
                                          >
                                            {idType.name}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={
                                          formData[`id_number${row.id}`] || ""
                                        }
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            [`id_number${row.id}`]:
                                              e.target.value,
                                          })
                                        }
                                        placeholder="ID Number"
                                      />
                                    </td>
                                    <td>
                                      <FileUpload
                                        onFileUploaded={(files) => {
                                          const fileArray = Array.isArray(files)
                                            ? files
                                            : [files];

                                          // Add id_row_id to each file
                                          const filesWithRowId = fileArray.map(
                                            (file) => ({
                                              ...file,
                                              id_row_id: row.id,
                                            }),
                                          );

                                          setIdDocuments((prev) => ({
                                            ...prev,
                                            [row.id]: [
                                              ...(prev[row.id] || []),
                                              ...filesWithRowId,
                                            ],
                                          }));
                                        }}
                                        accept=".pdf,image/*"
                                        multiple={true}
                                        buttonText="Upload PDF"
                                        buttonClass="btn btn-success btn-sm"
                                      />
                                      {idDocuments[row.id] &&
                                        idDocuments[row.id].length > 0 && (
                                          <div className="mt-2">
                                            {idDocuments[row.id].map(
                                              (doc, docIndex) => (
                                                <div
                                                  key={docIndex}
                                                  className="d-flex align-items-center justify-content-between mb-1 p-1 border rounded"
                                                >
                                                  <small
                                                    className="text-truncate"
                                                    style={{
                                                      maxWidth: "150px",
                                                      cursor: "pointer",
                                                      color: "#0d6efd",
                                                    }}
                                                    onClick={() => {
                                                      console.log(
                                                        "Document clicked:",
                                                        doc,
                                                      );
                                                      if (doc && doc.url) {
                                                        window.open(
                                                          `${process.env.REACT_APP_API_URL + doc.url}`,
                                                          "_blank",
                                                        );
                                                      } else {
                                                        console.error(
                                                          "Document URL not found:",
                                                          doc,
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    {doc.originalName ||
                                                      `Document ${docIndex + 1}`}
                                                  </small>
                                                  <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    style={{
                                                      padding: "2px 6px",
                                                      fontSize: "10px",
                                                    }}
                                                    onClick={() => {
                                                      setIdDocuments(
                                                        (prev) => ({
                                                          ...prev,
                                                          [row.id]: prev[
                                                            row.id
                                                          ].filter(
                                                            (_, i) =>
                                                              i !== docIndex,
                                                          ),
                                                        }),
                                                      );
                                                    }}
                                                  >
                                                    ✕
                                                  </button>
                                                </div>
                                              ),
                                            )}
                                          </div>
                                        )}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        style={{
                                          float: "right",
                                        }}
                                        className="btn btn-danger"
                                        onClick={() => removeIdRow(row.id)}
                                        disabled={idRows.length === 1}
                                      >
                                        <i class="bi bi-trash-fill"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="mt-3">
                            <button
                              style={{
                                float: "right",
                                marginTop: -16,
                              }}
                              type="button"
                              className="btn btn-primary"
                              onClick={addIdRow}
                            >
                              <i class="bi bi-plus-circle-fill"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Price Criteria Tab */}
                  {activeTab === "price" && workerType === "worker" && (
                    <div>
                      {/* Labour Charge */}
                      {/* <div className="row mb-3">
                        <div className="col-md-2">
                          <label className="form-label">Labour Charge</label>
                          <div className="input-group input-group-sm">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Labour charge/gram"
                              value={formData.labourCharge}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  labourCharge: e.target.value,
                                })
                              }
                            />
                            <select
                              className="form-select"
                              value={formData.labourCurrency}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  labourCurrency: e.target.value,
                                })
                              }
                            >
                              {(Array.isArray(state.currencies)
                                ? state.currencies
                                : []
                              ).map((currency) => (
                                <option key={currency.id} value={currency.code}>
                                  {currency.code}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">&nbsp;</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="labourType"
                                value="1"
                                checked={formData.labourChargeType === "1"}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    labourChargeType: e.target.value,
                                  })
                                }
                              />
                              <label className="form-check-label">
                                Gross Weight
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="labourType"
                                value="2"
                                checked={formData.labourChargeType === "2"}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    labourChargeType: e.target.value,
                                  })
                                }
                              />
                              <label className="form-check-label">
                                Net Weight
                              </label>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      {/* Detailed Sections - Always visible */}
                      <>
                        {/* Category Details Table */}
                        <div className="border rounded mb-3">
                          <h6 className="p-2 bg-light border-bottom mb-0">
                            Jewelry Category
                          </h6>
                          <div className="table-responsive">
                            <table className="table table-sm mb-0">
                              <thead>
                                <tr>
                                  <th width="15%">Category</th>
                                  <th width="15%">Rate</th>

                                  <th width="30%">Weight Type</th>
                                  <th width="30%">Charges Type</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Global Rate @</strong>
                                  </td>
                                  <td>
                                    <div className="input-group input-group-sm">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Rate"
                                        min="0"
                                        step="any"
                                        onKeyDown={(e) => {
                                          if (e.key === "-" || e.key === "e" || e.key === "E") {
                                            e.preventDefault();
                                          }
                                        }}
                                        value={formData.jewelryGlobalRate}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          if (val === "" || parseFloat(val) >= 0) {
                                            handleJewelryGlobalRateChange(val);
                                          }
                                        }}
                                      />
                                      <select
                                        className="form-select"
                                        value={formData.jewelryGlobalCurrency}
                                        onChange={(e) =>
                                          handleJewelryGlobalCurrencyChange(
                                            e.target.value,
                                          )
                                        }
                                      >
                                        {(Array.isArray(state.currencies)
                                          ? state.currencies
                                          : []
                                        ).map((currency) => (
                                          <option
                                            key={currency.id}
                                            value={currency.code}
                                          >
                                            {currency.code}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="jewelryWeight"
                                        value="1"
                                        checked={
                                          formData.jewelryWeightType === "1"
                                        }
                                        onChange={(e) =>
                                          handleJewelryGlobalWeightTypeChange(
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <label className="form-check-label">
                                        Fine
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="jewelryWeight"
                                        value="2"
                                        checked={
                                          formData.jewelryWeightType === "2"
                                        }
                                        onChange={(e) =>
                                          handleJewelryGlobalWeightTypeChange(
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <label className="form-check-label">
                                        Caratage
                                      </label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="jewelryCharges"
                                        value="1"
                                        checked={
                                          formData.jewelryChargesType === "1"
                                        }
                                        onChange={(e) =>
                                          handleJewelryGlobalChargesTypeChange(
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <label className="form-check-label">
                                        No. pcs
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="jewelryCharges"
                                        value="2"
                                        checked={
                                          formData.jewelryChargesType === "2"
                                        }
                                        onChange={(e) =>
                                          handleJewelryGlobalChargesTypeChange(
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <label className="form-check-label">
                                        Weight
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                                {(Array.isArray(state.jewelleryGroups)
                                  ? state.jewelleryGroups
                                  : []
                                ).map((category) => (
                                  <tr key={category.id}>
                                    <td>
                                      <strong>
                                        {category.name}
                                      </strong>
                                    </td>
                                    <td>
                                      <div className="input-group input-group-sm">
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Rate"
                                          min="0"
                                          step="any"
                                          onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e" || e.key === "E") {
                                              e.preventDefault();
                                            }
                                          }}
                                          value={
                                            formData[
                                            `category_${category.id}_rate`
                                            ] ||
                                            formData.jewelryGlobalRate ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === "" || parseFloat(val) >= 0) {
                                              setFormData({
                                                ...formData,
                                                [`category_${category.id}_rate`]: val,
                                              });
                                            }
                                          }}
                                        />
                                        <select
                                          className="form-select"
                                          value={
                                            formData[
                                            `category_${category.id}_currency`
                                            ] ||
                                            formData.jewelryGlobalCurrency ||
                                            "USD"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`category_${category.id}_currency`]:
                                                e.target.value,
                                            })
                                          }
                                        >
                                          {(Array.isArray(state.currencies)
                                            ? state.currencies
                                            : []
                                          ).map((currency) => (
                                            <option
                                              key={currency.id}
                                              value={currency.code}
                                            >
                                              {currency.code}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`categoryWeight_${category.id}`}
                                          value="1"
                                          checked={
                                            formData[
                                            `category_${category.id}_weightType`
                                            ] === "1" ||
                                            (formData.jewelryWeightType ===
                                              "1" &&
                                              !formData[
                                              `category_${category.id}_weightType`
                                              ])
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`category_${category.id}_weightType`]:
                                                e.target.value,
                                            })
                                          }
                                        />
                                        <label className="form-check-label">
                                          Fine
                                        </label>
                                      </div>
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`categoryWeight_${category.id}`}
                                          value="2"
                                          checked={
                                            formData[
                                            `category_${category.id}_weightType`
                                            ] === "2" ||
                                            (formData.jewelryWeightType ===
                                              "2" &&
                                              !formData[
                                              `category_${category.id}_weightType`
                                              ])
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`category_${category.id}_weightType`]:
                                                e.target.value,
                                            })
                                          }
                                        />
                                        <label className="form-check-label">
                                          Caratage
                                        </label>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`categoryCharges_${category.id}`}
                                          value="1"
                                          checked={
                                            formData[
                                            `category_${category.id}_chargesType`
                                            ] === "1" ||
                                            (formData.jewelryChargesType ===
                                              "1" &&
                                              !formData[
                                              `category_${category.id}_chargesType`
                                              ])
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`category_${category.id}_chargesType`]:
                                                e.target.value,
                                            })
                                          }
                                        />
                                        <label className="form-check-label">
                                          No. Pcs
                                        </label>
                                      </div>
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`categoryCharges_${category.id}`}
                                          value="2"
                                          checked={
                                            formData[
                                            `category_${category.id}_chargesType`
                                            ] === "2" ||
                                            (formData.jewelryChargesType ===
                                              "2" &&
                                              !formData[
                                              `category_${category.id}_chargesType`
                                              ])
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [`category_${category.id}_chargesType`]:
                                                e.target.value,
                                            })
                                          }
                                        />
                                        <label className="form-check-label">
                                          Weight
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Process & Stone Details */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="border rounded">
                              <h6 className="p-2 bg-light border-bottom mb-0">
                                Process Details
                              </h6>
                              <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                  <thead>
                                    <tr>
                                      <th>Process</th>
                                      <th>Rate</th>
                                      <th>Weight Type</th>
                                      <th>Allowed Loss (%)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <strong>Global Rate @</strong>
                                      </td>
                                      <td>
                                        <div className="input-group input-group-sm">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Rate"
                                            min="0"
                                            step="any"
                                            onKeyDown={(e) => {
                                              if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                e.preventDefault();
                                              }
                                            }}
                                            value={formData.processGlobalRate}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (val === "" || parseFloat(val) >= 0) {
                                                handleProcessGlobalRateChange(val);
                                              }
                                            }}
                                          />
                                          <select
                                            className="form-select"
                                            value={
                                              formData.processGlobalCurrency
                                            }
                                            onChange={(e) =>
                                              handleProcessGlobalCurrencyChange(
                                                e.target.value,
                                              )
                                            }
                                          >
                                            {(Array.isArray(state.currencies)
                                              ? state.currencies
                                              : []
                                            ).map((currency) => (
                                              <option
                                                key={currency.id}
                                                value={currency.code}
                                              >
                                                {currency.code}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="processWeight"
                                            value="1"
                                            checked={
                                              formData.processWeightType === "1"
                                            }
                                            onChange={(e) =>
                                              handleProcessGlobalWeightTypeChange(
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <label className="form-check-label">
                                            Gross
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="processWeight"
                                            value="2"
                                            checked={
                                              formData.processWeightType === "2"
                                            }
                                            onChange={(e) =>
                                              handleProcessGlobalWeightTypeChange(
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <label className="form-check-label">
                                            Net
                                          </label>
                                        </div>
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="%"
                                          min="0"
                                          step="any"
                                          onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e" || e.key === "E") {
                                              e.preventDefault();
                                            }
                                          }}
                                          value={
                                            formData.processGlobalAllowedLoss ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === "" || parseFloat(val) >= 0) {
                                              handleProcessGlobalAllowedLossChange(val);
                                            }
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    {(Array.isArray(state.processStages)
                                      ? state.processStages
                                      : []
                                    ).map((stage) => (
                                      <tr key={stage.id}>
                                        <td>
                                          <strong>{stage.name}</strong>
                                        </td>
                                        <td>
                                          <div className="input-group input-group-sm">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Rate"
                                              min="0"
                                              step="any"
                                              onKeyDown={(e) => {
                                                if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                  e.preventDefault();
                                                }
                                              }}
                                              value={
                                                formData[
                                                `process_${stage.id}_rate`
                                                ] ||
                                                formData.processGlobalRate ||
                                                ""
                                              }
                                              onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || parseFloat(val) >= 0) {
                                                  setFormData({
                                                    ...formData,
                                                    [`process_${stage.id}_rate`]: val,
                                                  });
                                                }
                                              }}
                                            />
                                            <select
                                              className="form-select"
                                              value={
                                                formData[
                                                `process_${stage.id}_currency`
                                                ] ||
                                                formData.processGlobalCurrency ||
                                                "USD"
                                              }
                                              onChange={(e) =>
                                                setFormData({
                                                  ...formData,
                                                  [`process_${stage.id}_currency`]:
                                                    e.target.value,
                                                })
                                              }
                                            >
                                              {(Array.isArray(state.currencies)
                                                ? state.currencies
                                                : []
                                              ).map((currency) => (
                                                <option
                                                  key={currency.id}
                                                  value={currency.code}
                                                >
                                                  {currency.code}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name={`processWeight_${stage.id}`}
                                              value="1"
                                              checked={
                                                formData[
                                                `process_${stage.id}_weightType`
                                                ] === "1" ||
                                                (formData.processWeightType ===
                                                  "1" &&
                                                  !formData[
                                                  `process_${stage.id}_weightType`
                                                  ])
                                              }
                                              onChange={(e) =>
                                                setFormData({
                                                  ...formData,
                                                  [`process_${stage.id}_weightType`]:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                            <label className="form-check-label">
                                              Gross
                                            </label>
                                          </div>
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name={`processWeight_${stage.id}`}
                                              value="2"
                                              checked={
                                                formData[
                                                `process_${stage.id}_weightType`
                                                ] === "2" ||
                                                (formData.processWeightType ===
                                                  "2" &&
                                                  !formData[
                                                  `process_${stage.id}_weightType`
                                                  ])
                                              }
                                              onChange={(e) =>
                                                setFormData({
                                                  ...formData,
                                                  [`process_${stage.id}_weightType`]:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                            <label className="form-check-label">
                                              Net
                                            </label>
                                          </div>
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            placeholder="%"
                                            min="0"
                                            step="any"
                                            onKeyDown={(e) => {
                                              if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                e.preventDefault();
                                              }
                                            }}
                                            value={
                                              formData[
                                              `process_${stage.id}_allowedLoss`
                                              ] ||
                                              formData.processGlobalAllowedLoss ||
                                              ""
                                            }
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (val === "" || parseFloat(val) >= 0) {
                                                setFormData({
                                                  ...formData,
                                                  [`process_${stage.id}_allowedLoss`]: val,
                                                });
                                              }
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="border rounded">
                              <h6 className="p-2 bg-light border-bottom mb-0">
                                Stone Type Handling
                              </h6>
                              <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                  <thead>
                                    <tr>
                                      <th>Stone Type</th>
                                      <th>Rate</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <strong>Global Rate @</strong>
                                      </td>
                                      <td>
                                        <div className="input-group input-group-sm">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Rate"
                                            min="0"
                                            step="any"
                                            onKeyDown={(e) => {
                                              if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                e.preventDefault();
                                              }
                                            }}
                                            value={formData.stoneGlobalRate}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (val === "" || parseFloat(val) >= 0) {
                                                handleStoneGlobalRateChange(val);
                                              }
                                            }}
                                          />
                                          <select
                                            className="form-select"
                                            value={formData.stoneGlobalCurrency}
                                            onChange={(e) =>
                                              handleStoneGlobalCurrencyChange(
                                                e.target.value,
                                              )
                                            }
                                          >
                                            {(Array.isArray(state.currencies)
                                              ? state.currencies
                                              : []
                                            ).map((currency) => (
                                              <option
                                                key={currency.id}
                                                value={currency.code}
                                              >
                                                {currency.code}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </td>
                                    </tr>
                                    {(Array.isArray(state.stoneTypes)
                                      ? state.stoneTypes
                                      : []
                                    ).map((stoneType) => (
                                      <tr key={stoneType.id}>
                                        <td>
                                          <strong>{stoneType.name}</strong>
                                        </td>
                                        <td>
                                          <div className="input-group input-group-sm">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Rate"
                                              min="0"
                                              step="any"
                                              onKeyDown={(e) => {
                                                if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                  e.preventDefault();
                                                }
                                              }}
                                              value={
                                                formData[
                                                `stone_${stoneType.id}_rate`
                                                ] ||
                                                formData.stoneGlobalRate ||
                                                ""
                                              }
                                              onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || parseFloat(val) >= 0) {
                                                  setFormData({
                                                    ...formData,
                                                    [`stone_${stoneType.id}_rate`]: val,
                                                  });
                                                }
                                              }}
                                            />
                                            <select
                                              className="form-select"
                                              value={
                                                formData[
                                                `stone_${stoneType.id}_currency`
                                                ] ||
                                                formData.stoneGlobalCurrency ||
                                                "USD"
                                              }
                                              onChange={(e) =>
                                                setFormData({
                                                  ...formData,
                                                  [`stone_${stoneType.id}_currency`]:
                                                    e.target.value,
                                                })
                                              }
                                            >
                                              {(Array.isArray(state.currencies)
                                                ? state.currencies
                                                : []
                                              ).map((currency) => (
                                                <option
                                                  key={currency.id}
                                                  value={currency.code}
                                                >
                                                  {currency.code}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <div className="border rounded">
                              <h6 className="p-2 bg-light border-bottom mb-0">
                                Setting Details
                              </h6>
                              <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                  <thead>
                                    <tr>
                                      <th>Setting Type</th>
                                      <th>Rate</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <strong>Global Rate @</strong>
                                      </td>
                                      <td>
                                        <div className="input-group input-group-sm">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Rate"
                                            min="0"
                                            step="any"
                                            onKeyDown={(e) => {
                                              if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                e.preventDefault();
                                              }
                                            }}
                                            value={formData.settingGlobalRate || ""}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (val === "" || parseFloat(val) >= 0) {
                                                handleSettingGlobalRateChange(val);
                                              }
                                            }}
                                          />
                                          <select
                                            className="form-select"
                                            value={
                                              formData.settingGlobalCurrency
                                            }
                                            onChange={(e) =>
                                              handleSettingGlobalCurrencyChange(
                                                e.target.value,
                                              )
                                            }
                                          >
                                            {(Array.isArray(state.currencies)
                                              ? state.currencies
                                              : []
                                            ).map((currency) => (
                                              <option
                                                key={currency.id}
                                                value={currency.code}
                                              >
                                                {currency.code}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </td>
                                    </tr>
                                    {(Array.isArray(state.settingTypes)
                                      ? state.settingTypes
                                      : []
                                    ).map((diamondType) => (
                                      <tr key={diamondType.id}>
                                        <td>
                                          <strong>{diamondType.name}</strong>
                                        </td>
                                        <td>
                                          <div className="input-group input-group-sm">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Rate"
                                              min="0"
                                              step="any"
                                              onKeyDown={(e) => {
                                                if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                  e.preventDefault();
                                                }
                                              }}
                                              value={
                                                formData[`diamond_${diamondType.id}_rate`] ??
                                                formData.settingGlobalRate ??
                                                ""
                                              }
                                              onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || parseFloat(val) >= 0) {
                                                  setFormData({
                                                    ...formData,
                                                    [`diamond_${diamondType.id}_rate`]: val,
                                                  });
                                                }
                                              }}
                                            />
                                            <select
                                              className="form-select"
                                              value={
                                                formData[
                                                `diamond_${diamondType.id}_currency`
                                                ] ||
                                                formData.settingGlobalCurrency ||
                                                "USD"
                                              }
                                              onChange={(e) =>
                                                setFormData({
                                                  ...formData,
                                                  [`diamond_${diamondType.id}_currency`]:
                                                    e.target.value,
                                                })
                                              }
                                            >
                                              {(Array.isArray(state.currencies)
                                                ? state.currencies
                                                : []
                                              ).map((currency) => (
                                                <option
                                                  key={currency.id}
                                                  value={currency.code}
                                                >
                                                  {currency.code}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="border rounded">
                              <h6 className="p-2 bg-light border-bottom mb-0">
                                Worker Overtime Rules
                              </h6>
                              <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                  <thead>
                                    <tr>
                                      <th>Day Name</th>
                                      <th>Multiplier</th>
                                      <th>Day Off</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Monday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="1.0"
                                          step="0.1"
                                          value={
                                            formData.monday_multiplier || "1.0"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              monday_multiplier: e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.monday_day_off || false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                monday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Tuesday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="1.0"
                                          step="0.1"
                                          value={
                                            formData.tuesday_multiplier || "1.0"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              tuesday_multiplier:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.tuesday_day_off || false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                tuesday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Wednesday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="1.0"
                                          step="0.1"
                                          value={
                                            formData.wednesday_multiplier ||
                                            "1.0"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              wednesday_multiplier:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.wednesday_day_off ||
                                              false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                wednesday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Thursday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="1.0"
                                          step="0.1"
                                          value={
                                            formData.thursday_multiplier ||
                                            "1.0"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              thursday_multiplier:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.thursday_day_off || false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                thursday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Friday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="1.0"
                                          step="0.1"
                                          value={
                                            formData.friday_multiplier || "1.0"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              friday_multiplier: e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.friday_day_off || false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                friday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Saturday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="1.5"
                                          step="0.1"
                                          value={
                                            formData.saturday_multiplier ||
                                            "1.5"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              saturday_multiplier:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.saturday_day_off || false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                saturday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Sunday</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="2.0"
                                          step="0.1"
                                          value={
                                            formData.sunday_multiplier || "2.0"
                                          }
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              sunday_multiplier: e.target.value,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={
                                              formData.sunday_day_off || false
                                            }
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                sunday_day_off:
                                                  e.target.checked,
                                              })
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success" disabled={isSavingWorker}>
                    {isSavingWorker && (
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    )}
                    {isSavingWorker ? "Saving..." : (editingWorker ? "Save Updates" : "Save Worker")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={isSavingWorker}
                    onClick={() => {
                      if (isSavingWorker) return;
                      setShowForm(false);
                      setEditingWorker(null);
                      setFormData(emptyForm);
                      setActiveTab("personal");
                      setAddressRows([{ id: 1 }]);
                      setIdRows([{ id: 1 }]);
                      setWorkerImages([]);
                      setWorkerPdfs([]);
                      setIdDocuments({});
                      closeDuplicateModal();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showDuplicateModal && (
        <div
          className="modal"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-warning-subtle">
                <h5 className="modal-title">Possible Duplicate Worker Found</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeDuplicateModal}
                  disabled={isSavingWorker}
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-3">
                  Some entered values already match existing worker records. You
                  can still continue and save this worker after review.
                </p>

                <div className="alert alert-warning py-2">
                  Matching workers: {duplicateCheckResult.totalMatchedWorkers} |
                  Matching fields: {duplicateCheckResult.totalMatchedFields}
                </div>

                {(duplicateCheckResult.matchedWorkers || []).map((worker) => (
                  <div key={worker.worker_id} className="card mb-3 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex flex-wrap gap-3 mb-2">
                        <strong>
                          {worker.worker_name || "Unnamed Worker"}
                        </strong>
                        {worker.worker_unid && (
                          <span className="text-muted">
                            ID: {worker.worker_unid}
                          </span>
                        )}
                        {worker.phone_no && (
                          <span className="text-muted">
                            Mobile: {worker.phone_no}
                          </span>
                        )}
                        {worker.email && (
                          <span className="text-muted">
                            Email: {worker.email}
                          </span>
                        )}
                      </div>

                      <div className="d-flex flex-column gap-2">
                        {worker.matchedFields.map((match, index) => (
                          <div
                            key={`${worker.worker_id}-${match.field}-${index}`}
                            className="border rounded px-3 py-2 bg-light"
                          >
                            <strong>{match.label}</strong>:{" "}
                            {match.existingValue}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeDuplicateModal}
                  disabled={isSavingWorker}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleDuplicateSaveConfirm}
                  disabled={isSavingWorker}
                >
                  {isSavingWorker && (
                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  )}
                  {isSavingWorker ? "Saving..." : "Save Anyway"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Info Modal */}
      {showInfoModal && selectedWorker && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{ backgroundColor: "#f0f4fb", padding: "8px 16px" }}
              >
                <h5 className="modal-title">
                  Worker/Employee Details -{" "}
                  {selectedWorker.worker_name || selectedWorker.name}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowInfoModal(false);
                    setSelectedWorker(null);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th width="40%">Worker / Employee ID</th>
                          <td>
                            <strong>{selectedWorker.worker_unid || "-"}</strong>
                          </td>
                        </tr>
                        <tr>
                          <th width="40%">Worker / Employee Name</th>
                          <td>
                            {selectedWorker.worker_name ||
                              selectedWorker.name ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Alias Name</th>
                          <td>
                            {selectedWorker.alias_name ||
                              selectedWorker.aliasName ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{selectedWorker.email || "-"}</td>
                        </tr>
                        <tr>
                          <th>Contact No.</th>
                          <td>
                            {selectedWorker.phone_no ||
                              selectedWorker.contactNo ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Department</th>
                          <td>{selectedWorker.department || "-"}</td>
                        </tr>
                        <tr>
                          <th>Position</th>
                          <td>{selectedWorker.position || "-"}</td>
                        </tr>
                        <tr>
                          <th>Type</th>
                          <td>{getWorkerTypeDisplay(selectedWorker)}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>
                            {(selectedWorker.status ?? 1) === 1 ? (
                              <span className="badge bg-success">Active</span>
                            ) : (
                              <span className="badge bg-danger">Inactive</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Joining Date</th>
                          <td>
                            {selectedWorker.joining_date ||
                              selectedWorker.joinDate ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Monthly Salary</th>
                          <td>
                            ₹
                            {selectedWorker.monthly_salary ||
                              selectedWorker.salary ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Notice Period(Days)</th>
                          <td>{selectedWorker.notice_period || "-"}</td>
                        </tr>
                        {!(
                          selectedWorker.type === 2 ||
                          selectedWorker.type === "2" ||
                          selectedWorker.type === "employee" ||
                          selectedWorker.worker_type === 2 ||
                          selectedWorker.worker_type === "2" ||
                          (selectedWorker.worker_unid &&
                            String(selectedWorker.worker_unid)
                              .trim()
                              .toUpperCase()
                              .startsWith("E"))
                        ) && (
                            <tr>
                              <th>Process Stage</th>
                              <td>
                                {getProcessStageName(
                                  selectedWorker.process_stage_id ||
                                  selectedWorker.processStages
                                ) || "-"}
                              </td>
                            </tr>
                          )}
                        <tr>
                          <th>Shift</th>
                          <td>
                            {getShiftName(selectedWorker.shiftId) || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Rating</th>
                          <td>
                            {selectedWorker.rating ||
                              selectedWorker.workerRating ||
                              0}
                            /5
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-6">
                    <h6>Account Information</h6>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th width="40%">Beneficiary Name</th>
                          <td>
                            {selectedWorker.accounts?.[0]?.beneficiary_name ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Account Number</th>
                          <td>
                            {selectedWorker.accounts?.[0]?.account_number ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Bank Name</th>
                          <td>
                            {selectedWorker.accounts?.[0]?.bank_name || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>IFSC Code</th>
                          <td>
                            {selectedWorker.accounts?.[0]?.ifsc_code || "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <h6 className="mt-3">ID Information</h6>
                    <table className="table table-bordered">
                      <tbody>
                        {selectedWorker.ids && selectedWorker.ids.length > 0 ? (
                          selectedWorker.ids.map((id, index) => (
                            <tr key={index}>
                              <th width="40%">
                                {state.companyIdTypes?.find(
                                  (type) => type.id == id.id_type_id,
                                )?.name || "ID Type"}
                              </th>
                              <td>{id.id_number || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              No ID information available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {selectedWorker.addresses &&
                  selectedWorker.addresses.length > 0 && (
                    <div className="mt-3">
                      <h6>Address Information</h6>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Address Line 1</th>
                            <th>Address Line 2</th>
                            <th>Country</th>
                            <th>State</th>
                            <th>City</th>
                            <th>Zip Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedWorker.addresses.map((addr, index) => (
                            <tr key={index}>
                              <td>{addr.address_type || "-"}</td>
                              <td>{addr.address_line1 || "-"}</td>
                              <td>{addr.address_line2 || "-"}</td>
                              <td>
                                {state.countries?.find(
                                  (c) => c.id == addr.country_id,
                                )?.name || "-"}
                              </td>
                              <td>
                                {state.states?.find(
                                  (s) => s.id == addr.state_id,
                                )?.name || "-"}
                              </td>
                              <td>
                                {state.cities?.find((c) => c.id == addr.city_id)
                                  ?.name || "-"}
                              </td>
                              <td>{addr.zip_code || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                {/* Images Gallery Section */}
                {selectedWorker.images && selectedWorker.images.length > 0 && (
                  <div className="mt-3">
                    <div className="image-gallery">
                      <h6 className="mb-2">Worker Images</h6>
                      <div className="row g-2">
                        {selectedWorker.images.map((image, index) => (
                          <div
                            key={image.id || index}
                            className="col-md-2 col-sm-3 col-4"
                          >
                            <div
                              className="card h-100"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                openImageModal(selectedWorker.images, index)
                              }
                            >
                              <img
                                src={API_BASE_URL + image.url}
                                alt={image.originalName || `Image ${index + 1}`}
                                className="card-img-top"
                                style={{ height: "80px", objectFit: "cover" }}
                              />
                              <div className="card-body p-1">
                                <small
                                  className="text-muted text-truncate d-block"
                                  style={{ fontSize: "10px" }}
                                >
                                  {image.originalName || `Image ${index + 1}`}
                                </small>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* PDFs Section */}
                {selectedWorker.pdfs && selectedWorker.pdfs.length > 0 && (
                  <div className="mt-3">
                    <h6 className="mb-2">Worker PDFs</h6>
                    <div className="row g-2">
                      {selectedWorker.pdfs.map((pdf, index) => (
                        <div key={pdf.id || index} className="col-md-2">
                          <div className="card">
                            <div className="card-body p-2">
                              <small
                                className="text-truncate d-block"
                                style={{ cursor: "pointer", color: "#0d6efd" }}
                                onClick={() => {
                                  if (pdf && pdf.url) {
                                    window.open(
                                      `${process.env.REACT_APP_API_URL + pdf.url}`,
                                      "_blank",
                                    );
                                  }
                                }}
                              >
                                📄 {pdf.originalName || `PDF ${index + 1}`}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* ID Documents Section */}
                {selectedWorker.documents &&
                  selectedWorker.documents.length > 0 && (
                    <div className="mt-3">
                      <h6 className="mb-2">ID Documents</h6>
                      <div className="row g-2">
                        {selectedWorker.documents.map((doc, index) => (
                          <div key={doc.id || index} className="col-md-2">
                            <div className="card">
                              <div className="card-body p-2">
                                <small
                                  className="text-truncate d-block"
                                  style={{
                                    cursor: "pointer",
                                    color: "#0d6efd",
                                  }}
                                  onClick={() => {
                                    if (doc && doc.url) {
                                      window.open(
                                        `${process.env.REACT_APP_API_URL + doc.url}`,
                                        "_blank",
                                      );
                                    }
                                  }}
                                >
                                  📄{" "}
                                  {doc.originalName || `Document ${index + 1}`}
                                </small>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* Price Criteria Section */}
                {(selectedWorker.type === "worker" || selectedWorker.type === 1 || selectedWorker.type === "1") && (
                  <div className="mt-3">
                    <h6>Price Criteria</h6>

                    {/* Category Prices */}
                    {selectedWorker.categoryPrices &&
                      selectedWorker.categoryPrices.length > 0 && (
                        <div className="mb-3">
                          <h6 className="h6">Jewelry Category Rates</h6>
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Category
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Currency
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Weight Type
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Charges Type
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedWorker.categoryPrices.map(
                                (cp, index) => (
                                  <tr key={index}>
                                    <td>
                                      {cp.jewellery_group_id === 0
                                        ? "Global Rate"
                                        : state.jewelleryGroups?.find(
                                          (c) => c.id == cp.jewellery_group_id,
                                        )?.name || "Unknown"}
                                    </td>
                                    <td>{cp.rate || "-"}</td>
                                    <td>{cp.currency || "-"}</td>
                                    <td>
                                      {cp.weight_type === "1"
                                        ? "Fine"
                                        : "Caratage"}
                                    </td>
                                    <td>
                                      {cp.charges_type === "1"
                                        ? "No. Pcs"
                                        : "Weight"}
                                    </td>
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}

                    {/* Process Prices */}
                    {selectedWorker.processPrices &&
                      selectedWorker.processPrices.length > 0 && (
                        <div className="mb-3">
                          <h6 className="h6">Process Stage Rates</h6>
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Process
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Currency
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Weight Type
                                </th>
                                <th
                                  width="20%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Allowed Loss (%)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedWorker.processPrices.map((pp, index) => (
                                <tr key={index}>
                                  <td>
                                    {pp.process_stage_id === 0
                                      ? "Global Rate"
                                      : state.processStages?.find(
                                        (p) => p.id == pp.process_stage_id,
                                      )?.name || "Unknown"}
                                  </td>
                                  <td>{pp.rate || "-"}</td>
                                  <td>{pp.currency || "-"}</td>
                                  <td>
                                    {pp.weight_type === "1" ? "Gross" : "Net"}
                                  </td>
                                  <td>{pp.allowed_loss || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                    {/* Stone Prices */}
                    {selectedWorker.stonePrices &&
                      selectedWorker.stonePrices.length > 0 && (
                        <div className="mb-3">
                          <h6 className="h6">Stone Type Rates</h6>
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th
                                  width="34%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Stone Type
                                </th>
                                <th
                                  width="33%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  width="33%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Currency
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedWorker.stonePrices.map((sp, index) => (
                                <tr key={index}>
                                  <td>
                                    {sp.stone_type_id === 0
                                      ? "Global Rate"
                                      : state.stoneTypes?.find(
                                        (s) => s.id == sp.stone_type_id,
                                      )?.name || "Unknown"}
                                  </td>
                                  <td>{sp.rate || "-"}</td>
                                  <td>{sp.currency || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                    {/* Setting Prices */}
                    {selectedWorker.settingPrices &&
                      selectedWorker.settingPrices.length > 0 && (
                        <div className="mb-3">
                          <h6 className="h6">Setting Rates</h6>
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th
                                  width="34%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Diamond Type
                                </th>
                                <th
                                  width="33%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  width="33%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Currency
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedWorker.settingPrices.map((sp, index) => (
                                <tr key={index}>
                                  <td>
                                    {sp.diamond_type_id === 0
                                      ? "Global Rate"
                                      : (state.settingTypes?.find(
                                        (d) => String(d.id) === String(sp.diamond_type_id),
                                      )?.name ||
                                        state.diamondTypes?.find(
                                          (d) => String(d.id) === String(sp.diamond_type_id),
                                        )?.name ||
                                        "Unknown")}
                                  </td>
                                  <td>{sp.rate || "-"}</td>
                                  <td>{sp.currency || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                    {/* Overtime Rules */}
                    {selectedWorker.overtimeRules &&
                      selectedWorker.overtimeRules.length > 0 && (
                        <div className="mb-3">
                          <h6 className="h6">Overtime Rules</h6>
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th
                                  width="34%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Day
                                </th>
                                <th
                                  width="33%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Multiplier
                                </th>
                                <th
                                  width="33%"
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  Day Off
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedWorker.overtimeRules.map(
                                (rule, index) => (
                                  <tr key={index}>
                                    <td>{rule.day_name}</td>
                                    <td>{rule.multiplier}x</td>
                                    <td>{rule.day_off ? "Yes" : "No"}</td>
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowInfoModal(false);
                    setSelectedWorker(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Modal with Slider */}
      {showImageModal && modalImages.length > 0 && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.9)" }}
          onClick={() => setShowImageModal(false)}
        >
          <div
            className="modal-dialog modal-lg"
            style={{ maxWidth: "90%", marginTop: "2%" }}
          >
            <div
              className="modal-content"
              style={{ backgroundColor: "transparent", border: "none" }}
            >
              <button
                type="button"
                className="btn-close btn-close-white"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  zIndex: 1050,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowImageModal(false);
                }}
              ></button>
              <div
                className="modal-body text-center"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={API_BASE_URL + modalImages[currentImageIndex].url}
                  alt={modalImages[currentImageIndex].originalName || "Image"}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                  }}
                />
                {modalImages.length > 1 && (
                  <>
                    <button
                      className="btn btn-light"
                      style={{
                        position: "absolute",
                        left: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 1050,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        prevImage();
                      }}
                    >
                      ❮
                    </button>
                    <button
                      className="btn btn-light"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 1050,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        nextImage();
                      }}
                    >
                      ❯
                    </button>
                    <div style={{ color: "white", marginTop: "10px" }}>
                      {currentImageIndex + 1} / {modalImages.length}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <PermissionGuard module={MODULES.WORKERS} action={ACTIONS.LIST}>
        <div className="card">
          <div className="card-body px-0 pt-0">
            <CommonTable
              dataSource={api.workers.table}
              queryParams={{
                worker_id: workerFilters.worker_id || undefined,
                worker_name: !workerFilters.worker_id ? workerFilters.worker_name : undefined,
                contact_no: workerFilters.contact_no,
                shiftId: workerFilters.shiftId,
              }}
              columns={workerTableColumns}
              onDataLoaded={(response) => setWorkersTableTotal(response?.pagination?.totalRecords || 0)}
              renderActions={renderWorkerTableActions}
            />
          </div>
        </div>
      </PermissionGuard>

      <PermissionGuard
        module={MODULES.WORKERS}
        action={ACTIONS.LIST}
        fallback={
          <div className="card">
            <div className="card-body text-center text-muted py-4">
              <p>You don't have permission to view the workers list</p>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default Workers;
